const esES = {
    common: {
        url: 'Url',
        or: 'o',
        date: {
            start: 'Comienza',
            end: 'Termina',
            format: 'DD MMM',
            type: 'DD-MM-YYYY HH:mm',
            formatInput: 'dd/MM/yyyy',
            formatField: 'DD-MM-YYYY HH:mm',
            formatView: 'LL',
        },
        hour: {
            format: 'HH:mm',
        },
        add: 'Añadir',
        cancel: 'Cancelar',
        reset: 'Limpiar',
        manage: 'Gestionar',
        save: 'Guardar',
        search: 'Buscar',
        edit: 'Editar',
        remove: 'Borrar',
        new: 'Nuevo',
        current: 'Actual',
        export: 'Exportar a Excel',
        noDataToExport: 'No hay datos para exportar',
        import: 'Importar',
        discard: 'Descartar',
        yes: 'Sí',
        no: 'No',
        pause: 'Pausar',
        areYouSure: '¿Estás seguro?',
        view: 'Ver',
        destroy: 'Eliminar',
        mustSelectARow: 'Debes seleccionar una fila',
        confirm: 'Confirmar',
        back: {
            default: 'Volver',
            admin: 'Volver a Superadmin',
            property: 'Volver a Gestor de Entidad',
        },
        create: 'Crear',
        update: 'Actualizar',
        next: 'Siguiente',
        backButton: 'Volver',
        none: 'Ninguno',
        overview: 'Resumen',
        seeAll: 'Ver todo',
        addEmail: 'Añadir Email',
        continue: 'Continuar',
        apply: 'Inscribirse',
        unknownError: 'Error desconocido, por favor inténtalo de nuevo o contacta con nuestro soporte',
        provided: 'Proporcionado',
        download: 'Descargar',
        downloadButton: {
            ios: {
                availableOn: 'Disponible en',
                nameStore: 'App Store'
            },
            android: {
                availableOn: 'Disponible en',
                nameStore: 'Google Play'
            }
        },
        match: 'Emaprejar', // TODO: paquete5
        unmatched: 'Sin emparejar',
        uploadFile: 'Subir archivo',
        characters: {
            singular: 'caracter',
            plural: 'caracteres',
        },
        never: 'Nunca',
        tbd: 'Por determinar',
        select: {
            placeholder: 'Seleccionar...'
        },
        start: 'Comenzar',
        done: 'Finalizar',
        complete: 'Completar',
        unverified: 'No verificado',
        replace: 'Reemplazar',
    },

    app: {
        title: 'OWQLO',
    },

    entities: {
        docs: {
            fields: {
                title: 'Título'
            },
            placeholders: {
                title: ''
            }
        },
        people: {
            name: 'people',
            menu: 'Gente',
        },
        teamRegistration: {
            fields: {
                clubName: 'Nombre del club',
                clubLegalName: 'Denominación social del club',
                clubType: 'Tipo de club',
                clubFederation: 'Federación territorial',
                clubLegalEntityId: 'CIF/NIF',
                clubWebsite: 'Página web del club',
                clubNeedsAccommodation: '¿Vas a necesitar alojamiento?',
                clubKitJersey: 'Colores de la camiseta',
                clubKitPants: 'Colores del pantalón',
            },
            placeholders: {
                clubLogo: 'Escudo del club',
                clubName: 'Nombre del club',
                clubLegalName: 'Nombre legal del club',
                clubType: 'Seleccionar uno...',
                clubFederation: 'Seleccionar una...',
                clubLegalEntityId: 'Ej.: S1111111D',
                clubWebsite: 'Ej.: www.atleticodemadridjunior.com',
            },
        },
        clubKitPiece: {
            fields: {
                type: 'Tipo de camiseta',
            },
        },
        clubContactPerson: {
            fields: {
                firstName: 'Nombre',
                lastName: 'Apellidos',
                position: 'Cargo',
                email: 'Email',
                phone: 'Teléfono',
            },
            placeholders: {
                firstName: 'Nombre del responsable',
                lastName: 'Apellidos del responsable',
                position: 'Ej.: Entrenador',
                email: 'Ej.: nombre@empresa.com',
            },
        },
        clubCategory: {
            fields: {
                gender: 'Género',
                format: 'Modalidad',
                ageCategory: 'Categoría del equipo',
                multipleTeams: '¿Vas a inscribir varios equipos en esta categoría?',
                minimumPlayersCommitment: 'Me comprometo a tener {0} jugadores en las plantillas de este/estos equipo/s',
            },
            placeholders: {
                ageCategory: 'Seleccionar una...',
                teamName: 'Ej.: A, B, etc.',
            },
        },
        inscription: {
            name: 'Registro',
            label: 'Registros',
            menu: 'Registros',
            exporterFileName: 'inscription_export',
            list: {
                menu: 'Registros',
                title: 'Registros',
            },
            create: {
                success: 'Registro guardada correctamente',
            },
            update: {
                success: 'Registro guardada correctamente',
            },
            destroy: {
                success: 'Registro eliminada correctamente',
            },
            destroyAll: {
                success: 'Registro(es) eliminadas correctamente',
            },
            edit: {
                title: 'Editar Registro',
            },
            fields: {
                id: 'Id',
                'status': 'Estado',
                'user': 'Usuario tutor',
                'name': 'Nombre',
                'firstName': 'Nombre',
                'lastName': 'Apellidos',
                'birthdate': 'Fecha de nacimiento',
                'gender': 'Sexo',
                'isMember': '¿Es actualmente miembro de este ${name}?',
                'careerInfo': 'Trayectoria deportiva',
                'identDoc': 'Número de ID',
                'identDocFiles': 'Uploading proof of Passport / ID document',
                'additionalDocFiles': 'Documentación adicional',
                'program': 'Programa',
                'subprogram': 'Categoría',
                'emailParent': 'Email tutor',
                'nameParent': 'Nombre tutor',
                createdAt: 'Creada en',
                updatedAt: 'Actualizada en',
                createdAtRange: 'Creada en',
                birthdateRange: 'Fecha de nacimiento',
            },
            placeholders: {
                firstName: 'Jorge',
                lastName: 'Sánchez',
                gender: 'Selecciona uno',
                birthdate: 'yyyy-mm-dd',
                careerInfo: 'Mi hijo/hija jugaba de defensa en...',
                identDoc: '12345678-X',
                additionalDocText: 'Por favor, descarga estos documentos y súbelos firmados.',
            },
            pending: {
                title: 'Inscripción pendiente de aprobación',
                message: 'Te hemos enviado un email con toda la información de tu solicitud.',
                buttonCaption: 'Ir a inicio',
            },
            matching: {
                default: 'Elige sexo y fecha de nacimiento para poder asignar un subprograma',
                loading: 'Realizando asignación, por favor espera ...',
                error: 'Lo sentimos, no hay equipo en este grupo de edad y género',
                success: 'Este jugador ha sido asignado a',
            },
            overview: {
                playersBornIn: 'Jugadores nacidos en {0}',
                playersBornInAnd: 'Jugadores nacidos en {0} y {1}',
                playersBornBetween: 'Jugadores nacidos entre {0} y {1}',
                unknownError: 'Ha ocurrido un error inesperado, por favor ponte en contacto con support@owqlo.com',
                parentDocLabel: 'Introduce el número de identidad del padre / madre para validar la el registro',
            },
            footer: {
                text: 'Si tienes algún problema con la inscripción, por favor contacta',
                email: 'support@owqlo.com',
            },
            form: {
                title: 'Inscripción de <strong>Jugadores</strong>',
                subtitle: {
                    info: 'Información de jugadores',
                    confirmation: 'Confirmación',
                },
            },
            new: {
                title: 'Crear Inscripción',
            },
            view: {
                title: 'Ver Inscripción',
                subtitle: {
                    familyMember: 'Miembro de familia',
                    player: 'Jugador'
                },
                fields: {
                    isMember: 'Es miembro?'
                },
                card: {
                    information: 'Información',
                    address: 'Dirección',
                    residentialAddress: 'Dirección de residencia',
                    programRegistration: 'Program ',
                    verification: 'Verificación',
                    aditionaDocuments: 'Documentos adicionales',
                }            },
            importer: {
                title: 'Importar Inscripciones',
                fileName: 'inscription_import_template',
                hint: 'Files/Images columns must be the URLs of the files separated by space.',
            },
            status: {
                pendingApproval: 'Pending approval'
            },
            modal: {
                title: 'Actualizar Jugador/a'
            },
            almostDone: {
                title: 'Te falta un último paso',
                step1: {
                    label: 'OWQLO',
                    caption: 'Cuenta padre / madre creada',
                },
                step2: {
                    caption: 'Inscribe a tu(s) hijo(s) a',
                },
            },
            remove: {
                title: 'Estás a punto de eliminar un jugador',
                message: '¿Estás seguro?',
            },
        },
        academy: {
            name: 'academy',
            label: 'Academias',
            menu: 'Academias',
            exporterFileName: 'academy_export',
            list: {
                menu: 'Academias',
                title: 'Academias',
            },
            create: {
                success: 'Academia se ha guardado correctamente',
            },
            update: {
                success: 'Academia se ha guardado correctamente',
            },
            destroy: {
                success: 'Academia se ha eliminado correctamente',
            },
            destroyAll: {
                success: 'Academia(s) se ha eliminado correctamente',
            },
            edit: {
                title: 'Editar Academia',
            },
            fields: {
                id: 'Id',
                'name': 'Nombre',
                'propertyOwner': 'PropertyOwner',
                createdAt: 'Creado en',
                updatedAt: 'Actualizado en',
                createdAtRange: 'Creado en',
            },
            enumerators: {

            },
            new: {
                title: 'Nueva Academia',
            },
            view: {
                title: 'Ver Academia',
            },
            importer: {
                title: 'Importar Academias',
                fileName: 'academy_import_template',
                hint: 'Files/Images columns must be the URLs of the files separated by space.',
            },
        },

        player: {
            name: 'player',
            singular: 'Jugador/a',
            label: 'Jugadores',
            amountOf: 'Número de jugadores',
            tooltipCaption: 'Jugadores activos actualmente',
            empty: 'No hay jugadores aún',
            menu: 'Jugadores',
            exporterFileName: 'player_export',
            add: {
                one: 'Añadir jugador/a',
                many: 'Añadir jugadores'  
            },
            list: {
                menu: 'Jugadores',
                title: 'Jugadores',
            },
            create: {
                success: 'Jugador se ha guardado correctamente',
            },
            update: {
                success: 'Jugador se ha guardado correctamente',
            },
            destroy: {
                success: 'Jugador se ha eliminado correctamente',
            },
            destroyAll: {
                success: 'Player(s) se ha eliminado correctamente',
            },
            edit: {
                title: 'Editar Jugador/a',
            },
            fields: {
                id: 'Id',
                'teams': 'Equipos',
                'name': 'Nombre',
                'firstName': 'Nombre',
                'lastName': 'Apellidos',
                'user': 'Usuario',
                'birthdate': 'Fecha de nacimiento',
                'picture': 'Foto',
                'country': 'País',
                'gender': 'Sexo',
                'isMember': 'Antiguo miembro',   //TODO:es
                'careerInfo': 'Trayectoria deportiva',//TODO:es
                'program': 'Programa',
                'subprogram': 'Subprograma',
                lastLogin: 'Última conexión',
                createdAt: 'Creado en',
                updatedAt: 'Actualizado en',
                createdAtRange: 'Creado en',
                birthdateRange: 'Fecha de nacimiento',
            },
            enumerators: {
                'gender': {
                    'male': 'Masculino',
                    'female': 'Femenino',
                },
            },
            new: {
                title: 'Nuevo/a Jugador/a',
            },
            view: {
                title: 'Ver Jugador/a',
                tabs: { 
                    profile: 'Perfil',
                    inscription: 'Registro'
                },
                cards: {
                    profile: 'Perfil'
                },
                btns: {
                    seeDetail: 'Ver detalles' 
                }
            },
            updateTeams: {
                action: 'Añadir equipos',
                title: 'Añadir equipos'
            },
            importer: {
                title: 'Importar Jugadores',
                fileName: 'player_import_template',
                hint: 'Files/Images columns must be the URLs of the files separated by space.',
            },
        },

        coach: {
            name: 'coach',
            label: 'Entrenadores',
            amountOf: 'Número de entrenadores',
            tooltipCaption: 'Entrenadores activos actualmente',
            empty: 'No hay entrenadores aún',
            menu: 'Entrenadores',
            exporterFileName: 'coach_export',
            list: {
                menu: 'Entrenadores',
                title: 'Entrenadores',
                multipleCoaches: 'Varios Entrenadores'
            },
            create: {
                success: 'Entrenador se ha guardado correctamente',
            },
            update: {
                success: 'Entrenador se ha guardado correctamente',
            },
            destroy: {
                success: 'Entrenador se ha eliminado correctamente',
            },
            destroyAll: {
                success: 'Entrenador(es) se ha eliminado correctamente',
            },
            edit: {
                title: 'Editar Entrenador',
            },
            fields: {
                id: 'Id',
                'teams': 'Equipos',
                'uid': 'Uid',
                'name': 'Nombre',
                'firstName': 'Nombre',
                'lastName': 'Apellidos',
                'birthdate': 'Fecha de nacimiento',
                'email': 'Email',
                'phoneNumber': 'Teléfono',
                'gender': 'Sexo',
                'country': 'País',
                'type': 'Tipo',
                lastLogin: 'Última conexión',
                createdAt: 'Creado en',
                updatedAt: 'Actualizado en',
                createdAtRange: 'Creado en',
            },
            enumerators: {
                'gender': {
                    'male': 'Masculino',
                    'female': 'Femenino',
                },
                'type': {
                    'coachHead': 'Entrenador principal',
                    'coachDirector': 'Director de Tecnificación',
                    'coach': 'Entrenador',
                    'coachAssistant': 'Segundo entrenador',
                    'schoolManager': 'Manager de la escuela',
                    'teamManager': 'Manager del equipo'
                },
            },
            new: {
                title: 'Nuevo Entrenador',
            },
            view: {
                title: 'Ver Entrenador',
            },
            importer: {
                title: 'Importar Entrenadores',
                fileName: 'coach_import_template',
                hint: 'Files/Images columns must be the URLs of the files separated by space.',
            },
            placeholders: {
                type: 'Selecciona uno...',
                firstName: 'Pep',
                lastName: 'Guardiola',
                birthdate: 'yyyy-mm-dd',
                gender: 'Selecciona uno...',
                country: 'Selecciona uno...',
                email: 'email@domain.com',
                teams: 'Selecciona uno...'
            },
            form: {
                subtitle: {
                    information: 'Información',
                    teams: 'Equipos'
                },
                tooltip: {
                    emailDisabled: 'Por motivos de privacidad no podemos modificar el correo electrónico', //TODO: 
                }
            }
        },

        parent: {
            name: 'parent',
            label: 'Padres',
            amountOf: 'Número de padres',
            tooltipCaption: 'Padres activos actualmente',
            empty: 'No hay padres aún',
            menu: 'Padres',
            exporterFileName: 'parent_export',
            list: {
                menu: 'Padres',
                title: 'Padres',
            },
            create: {
                success: 'Padres se ha guardado correctamente',
            },
            update: {
                success: 'Padres se ha guardado correctamente',
            },
            destroy: {
                success: 'Padres se ha eliminado correctamente',
            },
            destroyAll: {
                success: 'Padre(s) se ha eliminado correctamente',
            },
            edit: {
                title: 'Editar Padre',
            },
            fields: {
                id: 'Id',
                family: 'Familia',
                name: 'Nombre',
                firstName: 'Nombre',
                lastName: 'Apellido(s)',
                gender: 'Sexo',
                birthdate: 'Fecha de nacimiento',
                address: 'Dirección',
                email: 'Email',
                phoneNumber: 'Teléfono',
                createdAt: 'Creado en',
                lastLogin: 'Última conexión',
                updatedAt: 'Actualizado en',
                createdAtRange: 'Creado en',
                birthdateRange: 'Fecha de nacimiento',
            },
            enumerators: {

            },
            new: {
                title: 'Nuevo Parent',
            },
            view: {
                title: 'Ver Parent',
            },
            importer: {
                title: 'Importar Parents',
                fileName: 'parent_import_template',
                hint: 'Files/Images columns must be the URLs of the files separated by space.',
            },
        },

        family: {
            name: 'family',
            label: 'Familias',
            amountOf: 'Número de familias',
            empty: 'No hay familias aún',
            menu: 'Familias',
            exporterFileName: 'parent_export',
            list: {
                menu: 'Familias',
                title: 'Familias',
            },
            create: {
                success: 'Familias se ha guardado correctamente',
            },
            update: {
                success: 'Familias se ha guardado correctamente',
            },
            destroy: {
                success: 'Familias se ha eliminado correctamente',
            },
            destroyAll: {
                success: 'Familia(s) se ha eliminado correctamente',
            },
            edit: {
                title: 'Editar Familia',
            },
            fields: {
                id: 'Id',
                'gender': 'Sexo',
                'children': 'Hijos',
                'country': 'País',
                'email': 'Email',
                'role': 'Role',
                'birthdate': 'Fecha de nacimiento',
                createdAt: 'Creado en',
                updatedAt: 'Actualizado en',
                createdAtRange: 'Creado en',
            },
            new: {
                title: 'Nuevo Parent',
            },
            view: {
                title: 'Ver Parent',
            },
        },

        news: {
            name: 'news',
            label: 'Noticias',
            menu: 'Noticias',
            exporterFileName: 'news_export',
            list: {
                menu: 'Noticias',
                title: 'Noticias',
            },
            create: {
                success: 'Noticia se ha guardado correctamente',
            },
            update: {
                success: 'Noticia se ha guardado correctamente',
            },
            destroy: {
                success: 'Noticia se ha eliminado correctamente',
            },
            destroyAll: {
                success: 'Noticia(s) se ha eliminado correctamente',
            },
            edit: {
                title: 'Editar Noticia',
            },
            fields: {
                id: 'Id',
                'title': 'Título',
                'subtitle': 'Subtitle',
                'contentHtml': 'ContentHtml',
                'description': 'Description',
                'sourceUrl': 'SourceUrl',
                'media': 'Media',
                'status': 'Estado',
                'propertyOwner': 'PropertyOwner',
                createdAt: 'Creado en',
                updatedAt: 'Actualizado en',
                createdAtRange: 'Creado en',
            },
            enumerators: {
                'status': {
                    'draft': 'Draft',
                    'published': 'Published',
                },
            },
            new: {
                title: 'Nueva Noticia',
            },
            view: {
                title: 'Ver Noticias',
            },
            importer: {
                title: 'Importar Noticias',
                fileName: 'news_import_template',
                hint: 'Files/Images columns must be the URLs of the files separated by space.',
            },
        },

        training: {
            name: 'training',
            label: 'Entrenamientos',
            menu: 'Entrenamientos',
            exporterFileName: 'training_export',
            list: {
                menu: 'Entrenamientos',
                title: 'Entrenamientos',
            },
            create: {
                success: 'Entrenamiento se ha guardado correctamente',
            },
            update: {
                success: 'Entrenamiento se ha guardado correctamente',
            },
            destroy: {
                success: 'Entrenamiento se ha eliminado correctamente',
            },
            destroyAll: {
                success: 'Training(s) se ha eliminado correctamente',
            },
            edit: {
                title: 'Editar Training',
            },
            fields: {
                id: 'Id',
                'title': 'Título',
                'description': 'Description',
                'dateRange': 'Date',
                'date': 'Date',
                'hour': 'Hour',
                'duration': 'Duration',
                'location': 'Localización',
                'status': 'Estado',
                'team': 'Equipo',
                createdAt: 'Creado en',
                updatedAt: 'Actualizado en',
                createdAtRange: 'Creado en',
            },
            enumerators: {

            },
            new: {
                title: 'Nuevo Training',
            },
            view: {
                title: 'Ver Training',
            },
            importer: {
                title: 'Importar Entrenamientos',
                fileName: 'training_import_template',
                hint: 'Files/Images columns must be the URLs of the files separated by space.',
            },
        },

        game: {
            name: 'game',
            label: {
                one: 'Partido',
                many: 'Partidos',
            },
            menu: 'Partidos',
            exporterFileName: 'game_export',
            subtitle: {
                information: 'Incformación del partido',
            },
            list: {
                menu: 'Partidos',
                title: 'Partidos',
                empty: {
                    location: 'Sin localización',
                    date: 'Sin fecha',
                    hour: 'Sin hora',
                    school: 'Sin colegio',
                }
            },
            create: {
                success: 'Partido se ha guardado correctamente',
            },
            update: {
                success: 'Partido se ha guardado correctamente',
            },
            destroy: {
                success: 'Partido se ha eliminado correctamente',
            },
            destroyAll: {
                success: 'Partido(s) se ha eliminado correctamente',
            },
            edit: {
                title: 'Editar Partido',
            },
            fields: {
                id: 'Id',
                'awayTeam': 'Equipo visitante',
                'homeTeam': 'Equipo local',
                'timestamp': 'Fecha y hora',
                'date': 'Fecha',
                'hour': 'Hora',
                'duration': 'Duration',
                'location': 'Localización',
                'status': 'Estado',
                'type': 'Tipo',
                'results': 'Marcador',
                'locationInfo': 'Información extra de localización',
                'dateRange': 'Fecha entre',
                'teamToFilter': 'Equipo',
                'regularSeasonRound': 'Ronda',
                'playoff': 'Eliminatoria',
                createdAt: 'Creado en',
                updatedAt: 'Actualizado en',
                createdAtRange: 'Creado en',
            },
            placeholders: {
                hour: '16:00',
                location: 'Localización',
                locationInfo: 'Campo 1',
                timestamp: 'Selecciona fecha y hora ',
            },
            enumerators: {
                'status': {
                    'toPlay': 'ToPlay',
                    'firstHalf': 'FirstHalf',
                    'halfTime': 'HalfTime',
                    'secondHalf': 'SecondHalf',
                    'toEnd': 'ToEnd',
                    'penaltyShootout': 'PenaltyShootout',
                    'played': 'Played',
                },
            },
            new: {
                title: 'Nuevo Partido',
            },
            view: {
                title: 'Ver Partido',
            },
            importer: {
                title: 'Importar Partidos',
                fileName: 'game_import_template',
                hint: 'Files/Images columns must be the URLs of the files separated by space.',
            },
        },

        event: {
            name: 'event',
            label: 'Eventos',
            menu: 'Eventos',
            exporterFileName: 'event_export',
            list: {
                menu: 'Eventos',
                title: 'Eventos',
            },
            create: {
                success: 'Evento se ha guardado correctamente',
            },
            update: {
                success: 'Evento se ha guardado correctamente',
            },
            destroy: {
                success: 'Evento se ha eliminado correctamente',
            },
            destroyAll: {
                success: 'Event(s) se ha eliminado correctamente',
            },
            edit: {
                title: 'Editar Event',
            },
            fields: {
                id: 'Id',
                'title': 'Título',
                'description': 'Description',
                'dateRange': 'Date',
                'date': 'Date',
                'hour': 'Hour',
                'duration': 'Duration',
                'location': 'Localización',
                createdAt: 'Creado en',
                updatedAt: 'Actualizado en',
                createdAtRange: 'Creado en',
            },
            enumerators: {

            },
            new: {
                title: 'Nuevo Event',
            },
            view: {
                title: 'Ver Event',
            },
            importer: {
                title: 'Importar Eventos',
                fileName: 'event_import_template',
                hint: 'Files/Images columns must be the URLs of the files separated by space.',
            },
        },

        team: {
            name: 'team',
            label: { 
                one: 'Equipo',
                many: 'Equipos'
            },
            amountOf: 'Número de equipos',
            tooltipCaption: 'Equipos activos actualmente',
            empty: 'No hay equipos aún',
            menu: 'Equipos',
            exporterFileName: 'team_export',
            list: {
                menu: 'Equipos',
                title: 'Equipos',
                multipleTeams: 'Múltiples equipos'
            },
            create: {
                success: 'Equipo se ha guardado correctamente',
            },
            update: {
                success: 'Equipo se ha guardado correctamente',
            },
            destroy: {
                success: 'Equipo se ha eliminado correctamente',
            },
            destroyAll: {
                success: 'Equipo(s) se ha eliminado correctamente',
            },
            edit: {
                title: 'Editar Equipo',
            },
            fields: {
                id: 'Id',
                'name': 'Nombre',
                'category': 'Categoría',
                'program': 'Programa',
                'logo': 'Logo',
                'subprogram': 'Subprograma',
                'players': 'Nº Jugadores',
                'coaches': 'Entrenadores',
                'isMatched': 'Asignado',
                createdAt: 'Creado en',
                updatedAt: 'Actualizado en',
                createdAtRange: 'Creado en',
            },
            enumerators: {
                player: {
                    one: 'Jugador',
                    many: 'Jugadores'
                }
            },
            new: {
                title: 'Nuevo Equipo',
            },
            view: {
                title: 'Ver Equipo',
            },
            importer: {
                title: 'Importar Equipos',
                fileName: 'team_import_template',
                hint: 'Files/Images columns must be the URLs of the files separated by space.',
            },
        },

        position: {
            name: 'position',
            label: 'Positions',
            menu: 'Positions',
            exporterFileName: 'position_export',
            list: {
                menu: 'Positions',
                title: 'Positions',
            },
            create: {
                success: 'Position se ha guardado correctamente',
            },
            update: {
                success: 'Position se ha guardado correctamente',
            },
            destroy: {
                success: 'Position se ha eliminado correctamente',
            },
            destroyAll: {
                success: 'Position(s) se ha eliminado correctamente',
            },
            edit: {
                title: 'Editar Position',
            },
            fields: {
                id: 'Id',
                'name': 'Nombre',
                createdAt: 'Creado en',
                updatedAt: 'Actualizado en',
                createdAtRange: 'Creado en',
            },
            enumerators: {

            },
            new: {
                title: 'Nuevo Position',
            },
            view: {
                title: 'Ver Position',
            },
            importer: {
                title: 'Importar Positions',
                fileName: 'position_import_template',
                hint: 'Files/Images columns must be the URLs of the files separated by space.',
            },
        },

        fan: {
            name: 'fan',
            label: 'Fans',
            menu: 'Fans',
            exporterFileName: 'fan_export',
            list: {
                menu: 'Fans',
                title: 'Fans',
            },
            create: {
                success: 'Fan se ha guardado correctamente',
            },
            update: {
                success: 'Fan se ha guardado correctamente',
            },
            destroy: {
                success: 'Fan se ha eliminado correctamente',
            },
            destroyAll: {
                success: 'Fan(s) se ha eliminado correctamente',
            },
            edit: {
                title: 'Editar Fan',
            },
            fields: {
                id: 'Id',
                'name': 'Nombre',
                'lastName': 'LastName',
                'picture': 'Picture',
                'uid': 'Uid',
                'teams': 'Equipos',
                createdAt: 'Creado en',
                updatedAt: 'Actualizado en',
                createdAtRange: 'Creado en',
            },
            enumerators: {

            },
            new: {
                title: 'Nuevo Fan',
            },
            view: {
                title: 'Ver Fan',
            },
            importer: {
                title: 'Importar Fans',
                fileName: 'fan_import_template',
                hint: 'Files/Images columns must be the URLs of the files separated by space.',
            },
        },

        sheetEvent: {
            name: 'sheetEvent',
            label: 'SheetEvents',
            menu: 'SheetEvents',
            exporterFileName: 'sheetEvent_export',
            list: {
                menu: 'SheetEvents',
                title: 'SheetEvents',
            },
            create: {
                success: 'SheetEvent se ha guardado correctamente',
            },
            update: {
                success: 'SheetEvent se ha guardado correctamente',
            },
            destroy: {
                success: 'SheetEvent se ha eliminado correctamente',
            },
            destroyAll: {
                success: 'SheetEvent(s) se ha eliminado correctamente',
            },
            edit: {
                title: 'Editar SheetEvent',
            },
            fields: {
                id: 'Id',
                'type': 'Tipo',
                'subtypeGame': 'SubtypeGame',
                'subtypeGoal': 'SubtypeGoal',
                'subtypeCard': 'SubtypeCard',
                'subtypePenaltyShootout': 'SubtypePenaltyShootout',
                'teamId': 'TeamId',
                'minuteRange': 'Minute',
                'minute': 'Minute',
                'player': 'Player',
                'otherTeamId': 'OtherTeamId',
                createdAt: 'Creado en',
                updatedAt: 'Actualizado en',
                createdAtRange: 'Creado en',
            },
            enumerators: {
                'type': {
                    'game': 'Partido',
                    'goal': 'Goal',
                    'card': 'Card',
                    'penaltyShootout': 'PenaltyShootout',
                },
                'subtypeGame': {
                    'start': 'Start',
                    'firstHalfEnd': 'FirstHalfEnd',
                    'seconndHalfStart': 'SeconndHalfStart',
                    'secondHalfEnd': 'SecondHalfEnd',
                    'end': 'End',
                    'cancelStart': 'CancelStart',
                },
                'subtypeGoal': {
                    'standard': 'Standard',
                    'own': 'Own',
                    'penalty': 'Penalty',
                },
                'subtypeCard': {
                    'yellowCard': 'YellowCard',
                    'redCard': 'RedCard',
                },
                'subtypePenaltyShootout': {
                    'start': 'Start',
                    'goal': 'Goal',
                    'fail': 'Fail',
                    'end': 'End',
                },
            },
            new: {
                title: 'Nuevo SheetEvent',
            },
            view: {
                title: 'Ver SheetEvent',
            },
            importer: {
                title: 'Importar SheetEvents',
                fileName: 'sheetEvent_import_template',
                hint: 'Files/Images columns must be the URLs of the files separated by space.',
            },
        },

        site: {
            name: 'site',
            label: 'Sites',
            menu: 'Sites',
            exporterFileName: 'site_export',
            list: {
                menu: 'Sites',
                title: 'Sites',
            },
            create: {
                success: 'Site se ha guardado correctamente',
            },
            update: {
                success: 'Site se ha guardado correctamente',
            },
            destroy: {
                success: 'Site se ha eliminado correctamente',
            },
            destroyAll: {
                success: 'Site(s) se ha eliminado correctamente',
            },
            edit: {
                title: 'Editar Site',
            },
            fields: {
                id: 'Id',
                'name': 'Nombre',
                createdAt: 'Creado en',
                updatedAt: 'Actualizado en',
                createdAtRange: 'Creado en',
            },
            enumerators: {

            },
            new: {
                title: 'Nuevo Site',
            },
            view: {
                title: 'Ver Site',
            },
            importer: {
                title: 'Importar Sites',
                fileName: 'site_import_template',
                hint: 'Files/Images columns must be the URLs of the files separated by space.',
            },
        },

        club: {
            name: 'club',
            label: 'Clubs',
            menu: 'Clubs',
            exporterFileName: 'club_export',
            list: {
                menu: 'Clubs',
                title: 'Clubs',
            },
            create: {
                success: 'Club se ha guardado correctamente',
            },
            update: {
                success: 'Club se ha guardado correctamente',
            },
            destroy: {
                success: 'Club se ha eliminado correctamente',
            },
            destroyAll: {
                success: 'Club(s) se ha eliminado correctamente',
            },
            edit: {
                title: 'Editar Club',
            },
            fields: {
                id: 'Id',
                'name': 'Nombre',
                'logo': 'Logo',
                'teams': 'Equipos',
                createdAt: 'Creado en',
                updatedAt: 'Actualizado en',
                createdAtRange: 'Creado en',
            },
            enumerators: {

            },
            new: {
                title: 'Nuevo Club',
            },
            view: {
                title: 'Ver Club',
            },
            importer: {
                title: 'Importar Clubs',
                fileName: 'club_import_template',
                hint: 'Files/Images columns must be the URLs of the files separated by space.',
            },
        },

        service: {
            name: 'service',
            label: 'Services',
            menu: 'Services',
            exporterFileName: 'service_export',
            list: {
                menu: 'Services',
                title: 'Services',
            },
            create: {
                success: 'Service se ha guardado correctamente',
            },
            update: {
                success: 'Service se ha guardado correctamente',
            },
            destroy: {
                success: 'Service se ha eliminado correctamente',
            },
            destroyAll: {
                success: 'Service(s) se ha eliminado correctamente',
            },
            edit: {
                title: 'Editar Service',
            },
            fields: {
                id: 'Id',
                'name': 'Nombre',
                createdAt: 'Creado en',
                updatedAt: 'Actualizado en',
                createdAtRange: 'Creado en',
            },
            enumerators: {

            },
            new: {
                title: 'Nuevo Service',
            },
            view: {
                title: 'Ver Service',
            },
            importer: {
                title: 'Importar Services',
                fileName: 'service_import_template',
                hint: 'Files/Images columns must be the URLs of the files separated by space.',
            },
        },

        property: {
            name: 'property',
            label: 'Entidades',
            menu: 'Entidades',
            exporterFileName: 'property_export',
            list: {
                menu: 'Entidades',
                title: 'Entidades',
                multipleManagers: 'Varios gestores',
                filters: 'Filtros'
            },
            create: {
                success: 'Entidad se ha guardado correctamente',
            },
            update: {
                success: 'Entidad se ha guardado correctamente',
            },
            destroy: {
                success: 'Entidad se ha eliminado correctamente',
            },
            destroyAll: {
                success: 'Entidad(s) se ha eliminado correctamente',
            },
            edit: {
                title: '<strong>Editar</strong>  Entidad',
            },
            fields: {
                id: 'Id',
                'name': 'Nombre de la entidad',
                'access': 'Acceso',
                'status': 'Estado',
                'sport': 'Deporte',
                'country': 'País de la entidad',
                'type': 'Tipo',
                'logos': 'Logos',
                'managers': 'Gestores',
                'maxNumSubproperty': 'Número de subproperties',
                email: 'Email',
                emails: 'Email(s)',
                createdAt: 'Creado en',
                updatedAt: 'Actualizado en',
                createdAtRange: 'Creado en',
            },
            placeholders: {
                'name': 'Madrid CFF',
                'sport': 'Fútbol',
                'country': 'País',
                'type': 'Club',
                'maxNumSubproperty': '1',
                'uploadFile': 'Subir archivo',
                'access': 'Privado',
                'email': 'email@dominio.com',
                'noData': 'No hay coincidencias en la búsqueda'
            },
            form: {
                subtitle: {
                    information: 'Información de la entidad',
                    management: 'Gestión',
                    subproperties: 'Subentidades',
                    country: 'País',
                },

                description: {
                    email: 'Añade los managers de la entidad  para que reciban un correo y se registren'
                }
            },
            enumerators: {
                'sport': {
                    'basketball': 'Baloncesto',
                    'soccer': 'Fútbol',
                },
                'status': {
                    'enabled': 'Activo',
                    'disabled': 'Inactivo',
                },
                'access': {
                    'private': 'Privado',
                    'public': 'Público',
                },
            },
            new: {
                title: 'Crear entidad',
                button: 'Crear entidad'
            },
            view: {
                title: 'Ver Entidad',
            },
            importer: {
                title: 'Importar Entidades',
                fileName: 'property_import_template',
                hint: 'Files/Images columns must be the URLs of the files separated by space.',
            },
            requirementSteps: {
                title: '¡Hola {0}!',
                caption: 'Para empezar a utilizar tu cuenta, debes completar estos pasos.',
                progressCaption: '{0} paso(s) por completar',
                tooltipCaption: 'Termina los pasos para continuar',
                steps: {
                    property: {
                        title: 'Completa tu entidad',
                        linkCaption: 'Completar información'
                    },
                    profile: {
                        title: 'Completa tu perfil',
                        linkCaption: 'Completar información'
                    },
                }
            },
        },

        subproperty: {
            name: 'subentidad',
            label: 'Subentidades',
            menu: ' Subentidades',
            empty: 'No hay subentidades aún',
            exporterFileName: 'subproperty_export',
            list: {
                menu: 'Subentidades',
                title: 'Subentidades',
                multipleManagers: 'Varios gestores'
            },
            create: {
                success: 'Subentidad se ha guardado correctamente',
            },
            update: {
                success: 'Subentidad se ha guardado correctamente',
            },
            destroy: {
                success: 'Subentidad se ha eliminado correctamente',
            },
            destroyAll: {
                success: 'Subentidad(s) se ha eliminado correctamente',
            },
            edit: {
                title: 'Editar Subentidad',
            },
            fields: {
                id: 'Id',
                'name': 'Nombre de la subentidad',
                'status': 'Estado',
                'slug': 'Configura la URL',
                'access': 'Acceso',
                'country': 'País de la entidad',
                'region': 'Región',
                'managers': 'Gestores',
                'logo': 'Logo',
                'programs': 'Programas',
                'paymentsEnabled': '¿Pasarela de pagos Stripe activada?',
                'owqloFeeFixed': 'Comisión fija',
                'owqloFeePercentage': 'Comisión variable',
                'email': 'Email',
                'emails': 'Email(s)',
                'createdAt': 'Creado en',
                'updatedAt': 'Actualizado en',
                'createdAtRange': 'Creado en',
                'birthdateType': 'Selecciona con qué parámetro quieres definir tus categorías',
                'dateFormat': 'Formato de fecha',
                'timeFormat': 'Formato de hora',
            },
            placeholders: {
                'name': 'Nombre de la subentidad',
                'status': 'Estado',
                'slug': 'Slug',
                'access': 'Publico',
                'country': 'País',
                'region': 'Region',
                'logo': 'Logo',
                emails: 'Email(s)',
                email: 'name@domain.com',
            },
            form: {
                subtitle: {
                    information: 'Información',
                    management: 'Gestión',
                    settings: 'Configuración',
                },
                description: {
                    email: 'Añade los managers de la subentidad para que reciban un correo y se registren'
                }
            },
            enumerators: {
                'status': {
                    'enabled': 'Activo',
                    'disabled': 'Inactivo',
                },
                'access': {
                    'private': 'Privado',
                    'public': 'Público',
                },
            },
            new: {
                title: 'Crear subentidad',
                button: 'Crear subentidad'
            },
            view: {
                title: 'Ver Subentidad',
            },
            importer: {
                title: 'Importar Subentidades',
                fileName: 'subproperty_import_template',
                hint: 'Files/Images columns must be the URLs of the files separated by space.',
            },
            requirementSteps: {
                title: 'Hola {0}!',
                caption: 'Para empezar a usar tu cuenta, debes completar estos pasos.',
                progressCaption: '{0} paso(s) por completar',
                tooltipCaption: 'Termina los pasos para continuar',
                steps: {
                    categories: {
                        title: 'Crea tus categorías predeterminadas',
                        linkCaption: 'Crea categorías',
                    },
                    locations: {
                        title: 'Crea tus localizaciones',
                        linkCaption: 'Crea localizaciones',
                    },
                    setup: {
                        title: 'Añadir información de la empresa para la gestión financiera',
                        linkCaption: 'Cuenta asociada',
                    },
                    people: {
                        title: 'Añadir información sobre personas autorizadas',
                        linkCaption: 'Personas asociadas'
                    },
                    externalAccounts: {
                        title: 'Añadir método de retirada',
                        linkCaption: 'Método de retirada'
                    },
                    payouts: {
                        title: 'Configura la retirada de fondos automática',
                        linkCaption: 'Calendario de pagos'
                    },
                    slug: { 
                        title: 'Personaliza un enlace para tu página web',
                        linkCaption: 'Enlace web'
                    }
                }
            },
            finantialOverview: {
                title: 'Detalles de subentidad',
                slugCard: {
                    configSlugText: 'Configura tu URL para que te encuentren tus usuarios',
                    emptyText: 'No has configurado ninguna URL todavía',
                    infoText: 'Completa estos pasos para añadir la URL',
                    linkText: 'Ver detalles'
                },
                feeCard: {
                    infoText: 'Completa los pasos para añadir el fee',
                    owqloFeeText: `Comisión por pago`,
                    linkText: 'Ver detalles'
                },
                connectedAccountCard: {
                    emptyText: 'No hay cuenta asociada aún',
                    infoText: 'Completa los pasos para añadir una cuenta',
                    connectedAccountText: 'Cuenta asociada',
                    connectedAccountDisabledText: 'Cuenta asociada desabilitada; revisa los detalles, o contacta con support@owqlo.com',
                    connectedAccountIncompleteText: 'Cuenta asociada incompleta; se mantendrá deshabilitada hasta que se completen los pasos mostrados arriba',
                    enabled: 'Habilitada',
                    disabled: 'Deshabilitada'
                }
            },
            customize: {
                title: 'Configuración inicial', 
                subtitles: {
                    information: 'Información'
                },
                suportedCharacters: 'Caracteres admitidos: a-z, A-Z, 0-9, guión (-)',
                checkExists: {
                    loading: 'Comprobando que la URL no existe',
                    error: 'La URL ya existe',
                    success: 'La URL esta disponible',
                },
                labels: {
                    currentUrl: 'URL actual',
                    newUrl: 'Nueva URL'
                },
                noUrlSlug: 'Todavía no hay una URL configurada',
                update: {
                    success: 'La URL se ha guardado correctamente',
                    
                },
            },
            feeInfo: {
                title: 'Comisión por pago',
                description: 'Comisión de Stripe más gastos de gestión.',
                feeCardInfo: {
                    forEuropean: 'For European cards',
                    forNonEuropean: 'For non European cards',
                    forCountry: 'For national cards',
                    forInternational: 'For international cards',
                },
                checkList: {
                    0: 'Todo lo que necesitas para gestionar pagos',
                    1: 'Sin comisiones mensuales, ocultas de configuración'
                },
                smallText:'* Si es necesario convertir divisa, se aplicará una comisión adicional de {0}.'
            },
        },
        
        base: {
            name: 'sede',
            label: 'Sedes',
            menu: 'Sedes',
            empty: 'No hay sedes aún',
            list: {
                menu: 'Sedes',
                title: 'Sedes',
            },
            create: {
                success: 'La Sede se ha guardado correctamente',
            },
            update: {
                success: 'La Sede se ha actualizado correctamente',
            },
            destroy: {
                success: 'La Sede se ha eliminado correctamente',
            },
            destroyAll: {
                success: 'Sede(s) se han eliminado correctamente',
            },
            fields: {
                id: 'Id',
                'name': 'Nombre de la sede',
                'seasons': 'Temporadas',
                createdAt: 'Created at',
                updatedAt: 'Updated at',
                createdAtRange: 'Created at',
            },
            new: {
                title: 'Crear sede',
            },
            edit: {
                title: 'Editar sede',
            },
            view: {
                title: 'Ver sede',
            },
        },

        category: {
            name: 'category',
            label: {
                one: 'Categoría',
                many: 'Categorías'
            },
            menu: 'Categorías',
            defaultCategories: 'Categorías predeterminadas',
            ageCategories: 'Categorías de edad',
            exporterFileName: 'category_export',
            list: {
                menu: 'Categorías',
                title: 'Categorías',
                multipleCategories: 'Varias categorías',
            },
            create: {
                success: 'Categoría se ha guardado correctamente',
            },
            update: {
                success: 'Categoría se ha guardado correctamente',
            },
            destroy: {
                success: 'Categoría se ha eliminado correctamente',
            },
            destroyAll: {
                success: 'Categoría(s) se ha eliminado correctamente',
            },
            edit: {
                title: 'Editar Categoría',
            },
            fields: {
                id: 'Id',
                'name': 'Nombre',
                'label': 'Abreviatura',
                'index': 'Index',
                'minBirthDate': 'Nacidos desde',
                'maxBirthDate': 'Nacidos hasta',
                'intervalBirthYear': 'Nacidos entre',
                createdAt: 'Creado en',
                updatedAt: 'Actualizado en',
                createdAtRange: 'Creado en',
            },
            enumerators: {

            },
            new: {
                title: 'Crear Categoría',
            },
            view: {
                title: 'Ver Categoría',
            },
            importer: {
                title: 'Importar Categorías',
                fileName: 'category_import_template',
                hint: 'Files/Images columns must be the URLs of the files separated by space.',
            },
            placeholders: {
                yearStart: 'Año (Comienzo)',
                yearEnd: 'Año (Final)',
            },
        },

        season: {
            name: 'season',
            label: 'Temporadas',
            menu: 'Temporadas',
            exporterFileName: 'season_export',
            amountOf: 'Número de temporadas',
            empty: 'No hay temporadas aún',
            tooltipCaption: 'Temporadas activas actualmente',
            list: {
                menu: 'Temporadas',
                title: 'Temporadas',
                singular: 'Temporada'
            },
            create: {
                success: 'Temporada se ha guardado correctamente',
            },
            update: {
                success: 'Temporada se ha guardado correctamente',
            },
            destroy: {
                success: 'Temporada se ha eliminado correctamente',
            },
            destroyAll: {
                success: 'Temporada(s) se ha eliminado correctamente',
            },
            edit: {
                title: 'Editar Temporada',
            },
            fields: {
                id: 'Id',
                'description': 'Descripción',
                'type': 'Tipo de temporada',
                'name': 'Nombre de la temporada',
                createdAt: 'Creado en',
                updatedAt: 'Actualizado en',
                createdAtRange: 'Creado en',
            },
            new: {
                title: 'Nueva Temporada',
            },
            view: {
                title: 'Ver Temporada',
            },
            importer: {
                title: 'Importar Temporadas',
                fileName: 'season_import_template',
                hint: 'Files/Images columns must be the URLs of the files separated by space.',
            },
        },

        location: {
            name: 'location',
            label: 'Localizaciones',
            amountOf: 'Número de localizaciones',
            tooltipCaption: 'Localizaciones activas actualmente',
            empty: 'No hay localizaciones aún',
            menu: 'Localizaciones',
            exporterFileName: 'location_export',
            list: {
                menu: 'Localizaciones',
                title: 'Localizaciones',
            },
            create: {
                success: 'Localización se ha guardado correctamente',
            },
            update: {
                success: 'Localización se ha guardado correctamente',
            },
            destroy: {
                success: 'Localización se ha eliminado correctamente',
            },
            destroyAll: {
                success: 'Localización(s) se ha eliminado correctamente',
            },
            edit: {
                title: 'Editar Localización',
            },
            fields: {
                id: 'Id',
                'name': 'Nombre de la localización',
                'information': 'Información',
                'location': 'Localización',
                'access': 'Acceso',
                createdAt: 'Creado en',
                updatedAt: 'Actualizado en',
                createdAtRange: 'Creado en',
            },
            enumerators: {

            },
            new: {
                title: 'Nueva Localización',
            },
            view: {
                title: 'Ver Localización',
            },
            importer: {
                title: 'Importar Localizaciones',
                fileName: 'location_import_template',
                hint: 'Files/Images columns must be the URLs of the files separated by space.',
            },
            placeholders: {
                search: 'Buscar',
                information: 'Campo 1'
            },
        },

        price: {
            name: 'price',
            label: 'Prices',
            menu: 'Prices',
            exporterFileName: 'price_export',
            list: {
                menu: 'Prices',
                title: 'Prices',
            },
            create: {
                success: 'Precio se ha guardado correctamente',
            },
            update: {
                success: 'Precio se ha guardado correctamente',
            },
            destroy: {
                success: 'Precio se ha eliminado correctamente',
            },
            destroyAll: {
                success: 'Precio(s) se ha eliminado correctamente',
            },
            edit: {
                title: 'Editar Precio',
            },
            fields: {
                id: 'Id',
                'amountRange': 'Amount',
                'amount': 'Amount',
                'currency': 'Currency',
                createdAt: 'Creado en',
                updatedAt: 'Actualizado en',
                createdAtRange: 'Creado en',
            },
            enumerators: {
                'currency': {
                    'eu': 'EU',
                    'usd': 'USD',
                },
            },
            new: {
                title: 'Nuevo Precio',
            },
            view: {
                title: 'Ver Precio',
            },
            importer: {
                title: 'Importar Prices',
                fileName: 'price_import_template',
                hint: 'Files/Images columns must be the URLs of the files separated by space.',
            },
        },

        paymentOption: {
            name: 'payment option',
            label: 'Payment option',
            menu: 'Payment option',
            exporterFileName: 'payment-option_export',
            list: {
                menu: 'Opciones de pago',
                title: 'Opciones de pago',
            },
            create: {
                success: 'Payment option se ha guardado correctamente',
            },
            update: {
                success: 'Payment option se ha guardado correctamente',
            },
            destroy: {
                success: 'Payment option se ha eliminado correctamente',
            },
            destroyAll: {
                success: 'Payment option(s) se ha eliminado correctamente',
            },
            edit: {
                title: 'Editar Payment option',
            },
            fields: {
                id: 'Id',
                'type': 'Tipo',
                'status': 'Estado',
                'numberOfPayments': 'Number Of Payments',
                createdAt: 'Creado en',
                updatedAt: 'Actualizado en',
                createdAtRange: 'Creado en',
            },
            enumerators: {
                'type': {
                    'standard': 'Standard',
                    'installment': 'Installment',
                    'suscription': 'Suscription',
                },
                'status': {
                    'enabled': 'Activo',
                    'disabled': 'Inactivo',
                }
            },
            new: {
                title: 'Nuevo Payment option',
            },
            view: {
                title: 'Ver Payment option',
            },
            importer: {
                title: 'Importar Opciones de pago',
                fileName: 'payment-option_import_template',
                hint: 'Files/Images columns must be the URLs of the files separated by space.',
            },
        },

        program: {
            name: 'program',
            label: {
                one: 'Programa',
                many: 'Programas'
            },            
            amountOf: 'Número de programas',
            tooltipCaption: 'Programas activos actualmente',
            empty: 'No hay programas aún',
            menu: 'Programas',
            formSteps: {
                first: 'INFORMACIÓN',
                second: 'MÁS INFORMACIÓN',
                third: 'PUBLICAR',
            },
            exporterFileName: 'program_export',
            list: {
                menu: 'Programas',
                title: 'Programas',
                multipleSeasons: 'Varias Temporadas',
                multipleLocations: 'Varias localizaciones',
                starts: 'Comienza',
                ends: 'Termina',
            },
            create: {
                success: 'El programa se ha guardado correctamente',
            },
            update: {
                success: 'El programa se ha actualizado correctamente',
            },
            destroy: {
                success: 'El programa se ha eliminado correctamente',
            },
            destroyAll: {
                success: 'programa(s) se ha eliminado correctamente',
            },
            fields: {
                id: 'Id',
                'name': 'Nombre del programa',
                'sport': 'Deporte',
                'type': 'Tipo de programa',
                'categories': 'Categorías',
                'startDateRange': 'StartDate',
                'startDate': 'Fecha de inicio',
                'endDateRange': 'Finish Date Range',
                'endDate': 'Fecha de finalización',
                'activity': 'Actividad',

                'gender': 'Sexo',
                'season': 'Temporada',
                createdAt: 'Creado en',
                updatedAt: 'Actualizado en',
                createdAtRange: 'Creado en',
            },

            placeholders: {
                season: 'Temporada 2019/2020',
                name: 'Nombre del programa',
            },

            enumerators: {
                'type': {
                    'camp': 'Campamento',
                    'class': 'Clase',
                    'academy': 'Academia',
                    'league': 'Liga',
                    'tournament': 'Torneo',
                    'club': 'Club',
                    'school': 'Formación',
                },
                'status': {
                    'enabled': 'Activo',
                    'disabled': 'Inactivo',
                },
                'access': {
                    'private': 'Privado',
                    'public': 'Público',
                },
            },
            new: {
                title: 'Crear Programa',
                programType: {
                    'all': 'All',
                    'club': 'Crear Club',
                    'school': 'Crear Formación',
                    'campclinics': 'Crear Campus & Clinics',
                    'league': 'Crear Liga',
                    'tournament': 'Crear Torneo',
                },
            },
            edit: {
                title: 'Editar Programa',
                programType: {
                    'all': 'All',
                    'club': 'Editar Club',
                    'school': 'Editar Formación',
                    'campclinics': 'Editar Campus & Clinics',
                    'league': 'Editar Liga',
                    'tournament': 'Editar Torneo',
                },
            },
            view: {
                title: 'Ver Programa',
            },
            form: {
                title: {
                    programType: {
                        'all': 'All',
                        'club': 'Nuevo Club',
                        'school': 'Nueva Formación',
                        'campclinics': 'Nuevo Campus & Clinics',
                        'league': 'Nueva Liga',
                        'tournament': 'Nuevo Torneo',
                    },
                }, 
                subtitle: {
                    information: 'Información'
                }
            }, 
            importer: {
                title: 'Importar Programas',
                fileName: 'program_import_template',
                hint: 'Files/Images columns must be the URLs of the files separated by space.',
            },
        },
        subprogram: {
            name: 'subprogram',
            label: 'Subprogramas',
            menu: 'Subprogramas',
            exporterFileName: 'subprogram_export',
            formatDate: 'D MMMM',
            list: {
                menu: 'Subprogramas',
                title: 'Subprogramas',
                multipleDays: 'Varios días',
            },
            create: {
                success: 'Subprograma se ha guardado correctamente',
            },
            update: {
                success: 'Subprograma se ha guardado correctamente',
            },
            destroy: {
                success: 'Subprograma se ha eliminado correctamente',
            },
            destroyAll: {
                success: 'Subprograma(s) se ha eliminado correctamente',
            },
            edit: {
                title: 'Editar Subprograma',
            },
            fields: {
                id: 'Id',
                'name': 'Título',
                'type': 'Tipo',
                'category': 'Categoría',
                'categoryName': 'Nombre de la categoría',
                'bornBetween': 'Nacidos entre',
                'startDateRange': 'Fecha de inicio',
                'time': 'Duración',
                'dates': 'Fechas',
                'startDate': 'Empieza',
                'endDate': 'Termina',
                'dateRange': 'Fecha de inicio y fin',
                'subprogramDays': 'Días',
                'duration': 'Duración',
                'gender': 'Sexo',
                'season': 'Temporadas',
                'locations': 'Localizaciones',
                'access': 'Acceso',
                'status': 'Estado',
                'identDocNeeded': '¿Se requiere documento de identificación?',
                'competitions': {
                    title: "Competiciones",
                    btn: "Añadir competiciones",
                    label: "¿En qué competiciones compiten los equipos de esta categoría?"
                },
                payment: {
                    title: 'Información de pago',
                    exist: '¿Es un programa de pago?',
                    price: 'Precio',
                    type: 'Tipos de pago',
                    paymentOptions: 'Opciones de pago',
                    externalAccount: 'Cuenta destino',
                },
                tryout: {
                    title: 'Prueba',
                    exist: '¿Hay plazo de prueba?',
                    startDate: 'Fecha de inicio',
                    endDate: 'Fecha final',
                },
                additionalDoc: {
                    title: '¿Se requiere algún documento adicional?',
                    exist: '¿Se requiere algún documento adicional?',
                    text: 'Introduce la información necesaria para que el usuario sepa lo que tiene que hacer',
                },

                email: 'Email',
                emails: 'Email(s)',
                managers: 'Gestor(es)',
                createdAt: 'Creado en',
                updatedAt: 'Actualizado en',
                createdAtRange: 'Creado en',
                regularSeasonHasRounds: '¿La liga tiene rondas?'
            },
            placeholders: {
                'name': 'Título',
                'type': 'Tipo',
                'category': 'Seleccionar una...',
                'startDateRange': 'StartDate',
                'time': 'Duración',
                'startDate': 'dd-mm-aaaa',
                'subprogramDays': 'Días',
                'endDate': 'dd-mm-aaaa',
                'duration': 'Duración',
                'gender': 'Seleccionar uno...',
                'season': 'Temporadas',
                'locations': 'Localizaciones',
                'access': 'Acceso',
                'status': 'Estado',
                'price': 'Introduce un precio',
                tryout: {
                    startDate: 'Fecha de comienzo',
                    endDate: 'Fecha de finalización',
                },
            },
            form: {
                btnSubmit: {
                    asDraft: 'Borrador',
                    asPublish: 'Publicar'
                },

                subtitle: {
                    information: 'Información',
                    paymentInformation: 'Información de pago',
                    price: 'Precio',
                    moreInformation: 'Más información',
                    access: 'Acceso',
                    selectPaymentPlan: 'Selecciona plan de pago',
                    selectPaymentOptions: 'Select payment options',
                    tryout: 'Prueba',
                    competitionLeague: 'Competition league',
                    requiredDocuments: 'Documentos requeridos',
                    paymentActivity: 'Pagos' ,
                },
                payment: {
                    fee: {
                        label: 'Comisión',
                        forEuropean: 'Para tarjetas europeas',
                        forNonEuropean: 'Para tarjetas no europeas',
                        forCountry: 'Para tarjetas nacionales',
                        forInternational: 'Para tarjetas internacionales',
                        seeDetailsText: 'Ver',
                        seeDetailsLinkText: 'detalles',
                    },
                    toReceive: {
                        label: 'A recibir',
                        forEuropean: 'Para tarjetas europeas',
                        forNonEuropean: 'Para tarjetas no europeas',
                        forCountry: 'Para tarjetas nacionales',
                        forInternational: 'Para tarjetas internacionales',
                    },
                    infoText: {
                        draft: 'Estamos mejorando la plataforma para poder ofrecer más formas de pago.',
                        noDraft: 'Este subprograma ya se ha publicado, por lo tanto la información de pago no se puede editar.',
                    },
                    descriptionPrice: 'Introduce el precio de la categoría en el formulario, y visualiza el importe a recibir con las comisiones aplicadas.',
                }
            },
            modal: {
                status: {
                    message: '¿Estás seguro de que quieres actualizar el estado?',
                }
            },
            enumerators: {
                payment: {
                    type: {
                        standard: 'Pago único',
                    } 
                }
            },
            new: {
                title: 'Nuevo Subprograma',
            },
            view: {
                title: 'Ver Subprograma',
            },
            importer: {
                title: 'Importar Subprogramas',
                fileName: 'subprogram_import_template',
                hint: 'Files/Images columns must be the URLs of the files separated by space.',
            },
            nba: {
                tabs: {
                    summary: 'Resumen',
                    schedule: 'Calendario',
                    standings: 'Clasificaciones',
                    participants: 'Participantes',
                    players: 'Jugadores',
                    parents: 'Padres',
                    rounds: 'Rondas'
                },
                conference: {
                    teams: 'Equipos',
                    pairing: 'Emparejar',
                    east: {
                        title: 'Conferencia Este', 
                        division: {
                            southeast: 'División Sudeste',
                            atlantic: 'División Atlántica',
                            central: 'División Central',
                        }
                    },
                    west: {
                        title: 'Conferencia Oeste',
                        division: {
                            northwest: 'División Noroeste',
                            pacific: 'División Pacífico',
                            southwest: 'División Sudoeste',
                        },
                    }
                },
                rounds: {
                    name: 'Ronda',
                    label: 'Rondas',
                    empty: 'Todavía no hay rondas',
                    add: 'Añadir ronda',
                    edit: 'Editar ronda',
                    fields: {
                        id: 'Id',
                        hostingSchoolDivisionIndex: 'Escuela host',
                        startDate: 'Fecha de inicio',
                        endDate: 'Fecha de fin',
                        gamesConfigurationString: 'Enfrentamientos'
                    },
                    form: {
                        subtitle: 'Información de la ronda',
                        placeholders: {
                            gamesConfigurationString: 'Por ejemplo: 1v3, 2v3, 3v1',
                        }
                    },
                    create: 'Ronda creada correctamente',
                    update: 'Ronda actualizada correctamente',
                    destroy: 'Ronda eliminada correctamente'
                },
                playoffs: {
                    name: 'Eliminatorias'
                },
                create: {
                    title: 'Crear partidos',
                },
                edit: {
                    title: 'Editar categoría',
                },
                startSeason: {
                    button: 'Empezar temporada',
                    alerts: {
                        first: {
                            title: '¡La temporada va a comenzar!',
                            description: 'Si haces click en Continuar, comenzará la temporada y se crearán todos los partidos de tu liga. ¿Estás seguro?'
                        },
                        second: {
                            title: '¡Tienes equipos sin emparejar!',
                            description: 'Quedan {0} equipos por emparejar, ¿estás seguro de qué quieres crear todos los partidos?'
                        },
                        third: {
                            title: 'Creando partidos...',
                            description: ''
                        },
                        four: {
                            title: 'Partidos creados con éxito!',
                            description: 'Ya puedes editar los partidos para poder añadir la ubicación y la hora'
                        },
                        five: {
                            title: '¡Hay rondas sin configurar!',
                            description: 'No se puede empezar la temporada hasta que haya un mínimo de 2 rondas creadas.',
                        },
                        results: {
                            title: '¡Vas a cerrar el acta de partido!',
                            action: 'Si haces clic en Continuar, cerrarás el acta de partido y por tanto el resultado será:',
                            description: 'Enviaremos un email notificando tanto a los entrenadores como a ti del resultado final y todos los datos del partido.',
                        },
                    },
                },
                startPlayoffs: {
                    button: 'Empezar eliminatoria',
                    alerts: {
                      step1: {
                        title: '¡Va a empezar la fase de playoffs!',
                        description: 'Si haces click en continuar, empezará la creación de los partidos de playoff. ¿Estás seguro?'
                    },
                    step2: {
                        title: 'Creando partidos...',
                        description: ''
                    },
                    step3: {
                      title: 'Partidos creados con éxito!',
                      description: 'Ya puedes editar los partidos para poder añadir la ubicación y la hora'
                    },
                    warning: {
                      title: '¡Quedan {0} partidos por jugar!',
                      description: 'No puedes empezar la competición hasta que se jueguen todos los partidos de la fase anterior',
                      button: 'Ver partidos sin jugar'
                  },
                    },
                },
                buttons: {
                    startSeason: 'Empezar temporada'
                },
                
                team: {
                    summary: {
                        information: 'Información',
                        competition: 'Competición'
                    },
                    standings: {
                        division: 'División',
                        conference: 'Conferencia',
                        fields: {
                            teams: 'EQUIPOS',
                            w: 'V',
                            l: 'D',
                            win: '%V',
                            gb: 'DIF',
                            difference: '+/-',
                            home: 'LOCAL',
                            road: 'VISITANTE',
                            last4: '4 ÚLTIMOS',
                        }
                    }
                },
                participants: {
                    menu: 'Participantes'
                },
                school: {
                    newPair: {
                        title: 'Emparejar escuela',
                    },
                    editPair: {
                        title: 'Editar el equipo de la escuela'
                    }
                }
            }, 
        },
        stripe: {
            payment: 'Pagos',
            totalAmount: {
                title: 'Ingresos totales',
                card: {
                    paid: 'Pagado',
                    pending: 'Pendiente de pago'
                }
            },
            charges: {
                title: 'Cargos',
            },
        },
        stripeIncome: {
            tabs: {
                charges: 'Cargos',
                payouts: 'Retirada de fondos',
            },
            table: {
                fee: 'Comisión',
            }
        },
        stripeCharge: {
            fields: {
                id: 'Id',
                'connectedAccount' : 'Cuenta Asociada',
                'type': 'Tipo de cargo',
                'stripeChargeId': 'Nº de cargo',
                'stripeFee': 'Stripe Fee',
                'applicationFee': 'Application Fee',
                'amount': 'Importe',
                'currency': 'Moneda',
                'status': 'Estado',
                'paymentMethod': 'Método de pago',
                'user': 'Usuario',
                createdAt: 'Fecha',
                updatedAt: 'Actualizado en',
            }
        },
        stripeConnectedAccount: { 
            state: {
                enabled: 'Habilitada',
                disabled: 'Deshabilitada'
            },
            fields: {
                id: 'Id',
                'subpropertyName': 'Nombre de la subpropiedad',
                'phone': 'Teléfono',
                'url': 'URL',
                'stripeConnectedAccountId': 'ID de la cuenta asociada de Stripe',
                'country': 'País',
                'createdRange': 'Creado',
                'defaultCurrency': 'Moneda por defecto',
                'settings': 'Ajustes',
                'email': 'Email',
                'address': 'Dirección',
                'businessType': 'Business Type',
                'productDescription': 'Descripción del producto',
                'companyName': 'Nombre de la compañia',
                'companyTaxId': 'Company Tax ID',
                'personalIdNumber': 'Personal ID Number',
                'tosAccepted': 'Accepting the Stripe Terms of Service',
                'tosAcceptance': 'Accepted on {{date}}, using IP {{ip}}',
                'inscriptionTutorConfirmed': 'Tutor confirmation',
                'mcc': 'MCC',
                'firstName': 'Nombre',
                'lastName': 'Last Name',
                'birthdate': 'Birthdate',
                'verificationIdFront': 'Verification ID Document (Front)',
                'verificationIdBack': 'Verification ID Document (Back)',
                createdAt: 'Created at',
                updatedAt: 'Updated at',
                createdAtRange: 'Created at',
            },
            placeholders: {
                'phone': '+1-541-754-3010',
                'url': 'https://www.',
                'country': 'Seleccionar un país',
                'defaultCurrency': 'Selecciona una moneda',
                'email': 'email@domain.com',
                'businessType': 'Business Type',
                'productDescription': 'Descripción del producto',
                'companyName': 'Nombre de la compañia',
                'companyTaxId': 'Company Tax ID',
                'personalIdNumber': 'Personal ID Number',
                'mcc': 'MCC',
                'firstName': 'Sebastian',
                'lastName': 'Stevens',
                'birthdate': 'mm/dd/yyyy',
                'verificationIdFront': 'ID Document (Front)',
                'verificationIdBack': 'ID Document (Back)',
            },
            form: {
                title: {
                    company: 'Cuenta de <strong>Empresa</strong>',
                    individual: 'Cuenta <strong>Individual</strong>',
                },
                subtitle: {
                    information: 'Información',
                    address: 'Dirección',
                    verification: 'Verificación',
                }
            },
            create: {
                title: 'Crear cuenta',
                success: 'Cuenta creada correctamente'
            },
            update: {
                title: 'Editar cuenta',
                success: 'Cuenta editada correctamente'
            },
            policy: 'Al hacer click, acepta <a href="https://stripe.com/es/connect-account/legal#contrato-de-cuenta-conectada-de-stripe" target="_blank">el Acuerdo de Cuenta Asociada de Stripe</a>.',
        },
        stripePerson: {
            fields: {
                id: 'ID',
                stripePersonId: 'Stripe ID',
                created: 'Created',
                name: 'Nombre',
                firstName: 'Nombre',
                lastName: 'Apellido',
                birthdate: 'Fecha de nacimiento',
                jobTitle: 'Ocupación laboral',
                role: 'Cargos',
                isAccountOpener: 'Responsable',
                isDirector: 'Director',
                isExecutive: 'Ejecutivo',
                isOwner: 'Propietario (25% o más)',
                ownershipPercentage: 'Porcentaje de la compañia',
                address: 'Address',
                ssnLast4: {
                    default: 'SSN (Últimos 4 dígitos)',
                    US: 'SSN (Últimos 4 dígitos)',
                    CA: 'Número de seguro social (Últimos 4 dígitos)',
                },
                ssnLast4Provided: {
                    default: 'SSN (Últimos 4 dígitos)',
                    US: 'SSN (Últimos 4 dígitos)',
                    CA: 'Número de seguro social (Últimos 4 dígitos)',
                },
                email: 'Email',
                phone: 'Teléfono',
                requirements: 'Requerimientos',
                verification: 'Verificación de identidad',
                verificationIdFront: 'Documento de identidad (Anverso)',
                verificationIdBack: 'Documento de identidad (Reverso)',
                additionalDocumentFront: 'Documento adicional (Anverso)',
                additionalDocumentBack: 'Documento adicional (Reverso)',
                createdAt: 'Created at',
                updatedAt: 'Updated at',
                createdAtRange: 'Created at',
                createdRange: 'Created at',
            },
            placeholders: {
                firstName: 'Alejandro',
                lastName: 'Gómez',
                birthdate: 'yyyy-mm-dd',
                jobTitle: 'Empresario',
                email: 'usuario@mail.com',
                phone: '654 32 32 32',
                ownershipPercentage: '100',
                ssnLast4: '1234',
                verificationIdFront: 'Documento de identidad (Anverso)',
                verificationIdBack: 'Documento de identidad (Reverso)',
                additionalDocumentFront: 'Documento adicional (Anverso)',
                additionalDocumentBack: 'Documento adicional (Reverso)',
            },
            validation: {
                minAge: 'Debes tener al menos 13 años para utilizar las funcionalidades de pago.',
                accountOpener: 'Una cuenta asociada solo puede tener un representante.',
                maxOwnershipPercentage: 'El porcentaje de propiedad combinado entre todos los dueños no puede ser mayor de 100.',
                accountOpenerExecutiveOrOwner: 'El representante también debe ser un ejecutivo y/o un propietario.',
            },
            tooltips: {
                owner: 'Esta persona posee, en forma directa o indirecta, el 25% o más de participación accionaria en la empresa conforme a un contrato, acuerdo, entendimiento, relación o de otro modo.',
                accountOpener: 'Cada cuenta debe verificar a una persona facultada para representar a la organización ante Stripe.\n\nPara cambiar al representante, primero debes quitarle esta función a la persona que actualmente está marcada como tal.',
                director: 'Un miembro del directorio de la empresa que sea responsable de garantizar que la empresa cumple con sus obligaciones reglamentarias.',
                executive: 'Un ejecutivo, un gerente sénior o alguien que de otro modo desempeñe un cargo importante en la dirección y la administración de la empresa.',
                verificationId: {
                    default: 'Requisitos para verificar la identidad\n\nCopias escaneadas del anverso y el reverso del documento de identidad:\n\n- Pasaporte\n- Carné de conducir\n- ID card\n- Resident permit ID / U.S.Green Card / North Carolina Resident ID\n- Border Crossing Card\n- Child ID card\n- NYC Card\n- U.S. visa card\n\nLos archivos deben tener formato.jpeg o .png y pesar menos de 5MB. No podemos verificar archivos PDF.\n\nLos archivos deben ser a color y estar girados con la imagen hacia arriba.Toda la información debe leerse con claridad.',
                    US: 'Requisitos para verificar la identidad\n\nCopias escaneadas del anverso y el reverso del documento de identidad:\n\n- Pasaporte\n- Carné de conducir\n- ID card\n- Resident permit ID / U.S.Green Card / North Carolina Resident ID\n- Border Crossing Card\n- Child ID card\n- NYC Card\n- U.S. visa card\n\nLos archivos deben tener formato.jpeg o .png y pesar menos de 5MB. No podemos verificar archivos PDF.\n\nLos archivos deben ser a color y estar girados con la imagen hacia arriba.Toda la información debe leerse con claridad.',
                    CA: 'Requisitos para verificar la identidad\n\nCopias escaneadas del anverso y el reverso del documento de identidad:\n- Pasaporte\n- Carné de conducir\n- ID card\n- National ID\n- Resident permit ID\n- Certificat de citoyenneté canadienne \n\nLos archivos deben tener formato .jpeg o .png y pesar menos de 5MB. No podemos verificar archivos PDF.\n\nLos archivos deben ser a color y estar girados con la imagen hacia arriba. Toda la información debe leerse con claridad.',
                    ES: 'Requisitos para verificar la identidad\n\nCopias escaneadas del anverso y el reverso del documento de identidad:\n- Pasaporte\n- Carné de conducir\n- DNI\n- Tarjeta de Identidad de Extranjero Card\n\nLos archivos deben tener formato .jpeg o .png y pesar menos de 5MB. No podemos verificar archivos PDF.\n\nLos archivos deben ser a color y estar girados con la imagen hacia arriba. Toda la información debe leerse con claridad.',
                },
                additionalDocument: {
                    default: 'Un documento que muestre la dirección, ya sea un pasaporte, un documento de identidad local o una factura de una conocida empresa de servicios públicos.',
                },
            },
            form: {
                title: '<strong>Cuenta de las personas</strong> asociadas',
                subtitle: {
                    information: 'Información',
                    address: 'Dirección',
                    verification: 'Verificación de identidad',
                    additionalDocument: 'Documento adicional',
                }
            },
            create: {
                title: 'Crear cuenta',
                success: 'Cuenta creada correctamente'
            },
            update: {
                title: 'Edit person',
                success: 'Person updated successfully'
            },
            enumerators: {
                personType: {
                    accountOpener: 'Representante',
                    director: 'Director',
                    executive: 'Ejecutivo',
                    owner: 'Propietario',
                    default: 'None'
                }
            }
        },
        stripeExternalAccount: {
            fields: {
                id: 'Id',
                holderName: 'Titular de la cuenta',
                holderType: 'Tipo de titular',
                country: 'País',
                currency: 'Moneda',
                sortCode: 'Código de clasificación (Sort code)',
                transitNumber: 'Número de tránsito (Transit number)',
                institutionNumber: 'Número de institución (Institution number)',
                routingNumber: 'Número de ruta (Routing number)',
                accountNumber: 'Número de cuenta',
                ibanNumber: 'IBAN',
                defaultForCurrency: 'Marcar como método por defecto',
                createdAt: 'Creado en',
                updatedAt: 'Actualizado en',
            },
            placeholders: {
                holderName: 'Gabriel Moreira',
                holderType: 'Selecciona una',
                sortCode: '12-34-56',
                transitNumber: '12345',
                institutionNumber: '123',
                routingNumber: '110000000',
                accountNumber: 'El formato puede variar según el banco',
                ibanNumber: 'IBAN',
            },
            form: {
                title: {
                    bankAccount: '<strong>Cuenta</strong> bancaria',
                    card: '<strong>Tarjeta</strong> débito',
                },
                subtitle: {
                    information: 'Información de la cuenta bancaria',
                }
            },
            create: {
                title: 'Crear método de retirada',
                success: 'Método de retirada creado correctamente'
            },
            update: {
                title: 'Editar método de retirada',
                success: 'Método de retirada actualizado correctamente'
            },
        },
        stripePayout: {
            fields: {
                id: 'Id',
                'created': 'Creado',
                'property': 'Entidad',
                'stripePayoutId': 'Stripe Payout ID',
                'connectedAccount': 'Connected Account',
                'externalAccount': 'External Account',
                'amount': 'Cantidad',
                'arrivalDate': 'Fecha',
                'subproperty': 'Subentidad', 
                'currency': 'Moneda',
                'description': 'Descripción',
                'method': 'Método de retirada',
                'statementDescriptor': 'Statement Descriptor',
                'status': 'Estado',
                'type': 'Tipo de retirada',
                'stripeFee': 'Cuota',
                createdAt: 'Creado en',
                updatedAt: 'Actualizado en',
            },
        },
        address: {
            fields: {
                'city': 'Ciudad',
                'townOrCity': 'Pueblo o ciudad',
                'country': 'País',
                'line1': 'Dirección 1',
                'line2': 'Dirección 2',
                'zipCode': 'Código postal',
                'postalCode': 'Código postal',
                'province': 'Provincia',
                'state': 'Estado',
                'stateProvinceRegion': 'Estado / Provincia / Región',
            },
            placeholders: {
                'city': 'Ciudad',
                'townOrCity': 'Pueblo o ciudad',
                'country': 'País',
                'line1': 'Calle, número, planta',
                'line2': 'Información adicional',
                'zipCode': '10001',
                'postalCode': '10001',
                'province': 'Provincia',
                'state': 'Estado',
                'stateProvinceRegion': 'Estado / Provincia / Región',
            }
        },
        phone: {
            fields: {
                'phone': 'Número de teléfono',
                'prefix': 'Prefijo',
                'number': 'Número',
            },
            placeholders: {
                'prefix': '+34',
                'number': '612345678',
            }
        },
        school: {   // TODO: 
            name: 'school',
            label: 'Escuelas',
            menu: 'Escuelas',
            empty: 'No hay escuelas aún',
            unmatch: 'Desemparejar',
            list: {
                menu: 'School',
                title: 'School',
                multipleCategories: 'Varias categorías'
            },
            form: {
                subtitle: {
                    information: 'Información',
                    management: 'Gestión',
                },
                description: { // TODO: paquete 5
                    email: 'Añade los gestores de la escuela para que reciban un correo electrónico y se registren'
                }
            },
            create: {
                success: 'School saved successfully',
            },
            update: {
                success: 'School saved successfully',
            },
            destroy: {
                success: 'School deleted successfully',
            },
            destroyAll: {
                success: 'Familie(s) deleted successfully',
            },
            fields: {
                id: 'Id',
                'name': 'Nombre de la escuela',
                'teams': 'Equipos',
                'categories': 'Categorías',
                'location': 'Localización',
                'coaches': 'Managers',
                'emails': 'Emails',
                createdAt: 'Created at',
                updatedAt: 'Updated at',
                createdAtRange: 'Created at',
            },
            placeholders: {
                fillSchool: 'Encuentra tu escuela',
                emptySchool: 'Introduce un nombre',
                name: 'Nombre de la escuela',
                location: 'Localización',
                email: 'name@domain.com',
            },
            new: {
                title: 'Crear Escuela',
            },
            edit: {
                title: 'Editar Escuela',
            },
            view: {
                title: 'Ver Escuela',
                fields: {
                    franchise: 'Franquicia',
                    category: 'Categoría',
                    location: 'Localización',
                    manager: 'Manager'
                }
            }
        },
        
        wallet: {
            payout: {
                one: 'Retirar fondos',
            },
            buttons: {
                historic: 'Histórico',
                total: 'Total'
            },
            links: {
                payouts: 'Ver retirada de fondos',
            },
            balance: {
                title: 'Balance',
                total: 'Total:',
                available: {
                    title: 'Disponible',
                    tooltipCaption: 'Dinero disponible'
                },
                pending: {
                    title: 'Pendiente',
                    tooltipCaption: 'Dinero pendiente'
                },
                transit: {
                    title: 'En camino',
                    tooltipCaption: 'Dinero en camino'
                }
            },
            activity: {
                title: 'Actividad',
            },
            empty: 'Vacío',
        },
        propertyWallet: {
            title: {
                accounts: 'Mis cuentas:',
                payout: 'Retirada de fondos:',
            },
            list: {
                wallet: 'Cartera de {0}',
            },
            table: {
                title: 'Dashboard',
            },
        },
    },
    newsletter: {
        name: 'newsletter',
        label: 'Newsletters',
        menu: 'Newsletters',
        exporterFileName: 'newsletter_export',
        list: {
            menu: 'Newsletters',
            title: 'Newsletters',
        },
        create: {
            success: 'Newsletter se ha guardado correctamente',
        },
        update: {
            success: 'Newsletter se ha guardado correctamente',
        },
        destroy: {
            success: 'Newsletter se ha eliminado correctamente',
        },
        destroyAll: {
            success: 'Newsletter(s) se ha eliminado correctamente',
        },
        edit: {
            title: 'Editar Newsletter',
        },
        fields: {
            id: 'Id',
            'name': 'Nombre',
            'lastname': 'Apellido(s)',
            'email': 'Email',
            'zipcode': 'Código postal',
            'state': 'Provincia',
            createdAt: 'Creado en',
            updatedAt: 'Actualizado en',
            createdAtRange: 'Creado en',
        },
        enumerators: {
            'state': {
                'Alabama': 'Alabama',
                'Alaska': 'Alaska',
                'American_Samoa': 'American_Samoa',
                'Arizona': 'Arizona',
                'Arkansas': 'Arkansas',
                'California': 'California',
                'Colorado': 'Colorado',
                'Connecticut': 'Connecticut',
                'Delaware': 'Delaware',
                'District_Of_Columbia': 'District_Of_Columbia',
                'Federated_States_Of_Micronesia': 'Federated_States_Of_Micronesia',
                'Florida': 'Florida',
                'Georgia': 'Georgia',
                'Guam': 'Guam',
                'Hawaii': 'Hawaii',
                'Idaho': 'Idaho',
                'Illinois': 'Illinois',
                'Indiana': 'Indiana',
                'Iowa': 'Iowa',
                'Kansas': 'Kansas',
                'Kentucky': 'Kentucky',
                'Louisiana': 'Louisiana',
                'Maine': 'Maine',
                'Marshall_Islands': 'Marshall_Islands',
                'Maryland': 'Maryland',
                'Massachusetts': 'Massachusetts',
                'Michigan': 'Michigan',
                'Minnesota': 'Minnesota',
                'Mississippi': 'Mississippi',
                'Missouri': 'Missouri',
                'Montana': 'Montana',
                'Nebraska': 'Nebraska',
                'Nevada': 'Nevada',
                'New_Hampshire': 'New_Hampshire',
                'New_Jersey': 'New_Jersey',
                'New_Mexico': 'New_Mexico',
                'New_York': 'New_York',
                'North_Carolina': 'North_Carolina',
                'North_Dakota': 'North_Dakota',
                'Northern_Mariana_Islands': 'Northern_Mariana_Islands',
                'Ohio': 'Ohio',
                'Oklahoma': 'Oklahoma',
                'Oregon': 'Oregon',
                'Palau': 'Palau',
                'Pennsylvania': 'Pennsylvania',
                'Puerto_Rico': 'Puerto_Rico',
                'Rhode_Island': 'Rhode_Island',
                'South_Carolina': 'South_Carolina',
                'South_Dakota': 'South_Dakota',
                'Tennessee': 'Tennessee',
                'Texas': 'Texas',
                'Utah': 'Utah',
                'Vermont': 'Vermont',
                'Virgin_Islands': 'Virgin_Islands',
                'Virginia': 'Virginia',
                'Washington': 'Washington',
                'West_Virginia': 'West_Virginia',
                'Wisconsin': 'Wisconsin',
                'Wyoming': 'Wyoming',
            },
        },
        new: {
            title: 'Nuevo Newsletter',
        },
        view: {
            title: 'Ver Newsletter',
        },
        importer: {
            title: 'Importar Newsletters',
            fileName: 'newsletter_import_template',
            hint: 'Files/Images columns must be the URLs of the files separated by space.',
        },
    },

    comment: {
        name: 'comment',
        label: 'Comments',
        menu: 'Comments',
        exporterFileName: 'comment_export',
        list: {
            menu: 'Comments',
            title: 'Comments',
        },
        create: {
            success: 'Comment se ha guardado correctamente',
        },
        update: {
            success: 'Comment se ha guardado correctamente',
        },
        destroy: {
            success: 'Comment se ha eliminado correctamente',
        },
        destroyAll: {
            success: 'Comment(s) se ha eliminado correctamente',
        },
        edit: {
            title: 'Editar Comment',
        },
        fields: {
            id: 'Id',
            'admin': 'Owner',
            'comment': 'Comment',
            'status': 'Estado',
            createdAt: 'Creado en',
            updatedAt: 'Actualizado en',
            createdAtRange: 'Creado en',
        },
        enumerators: {
            'status': {
                'publish': 'Publish',
                'draft': 'Draft',
            },
        },
        new: {
            title: 'Nuevo Comment',
        },
        view: {
            title: 'Ver Comment',
        },
        importer: {
            title: 'Importar Comments',
            fileName: 'comment_import_template',
            hint: 'Files/Images columns must be the URLs of the files separated by space.',
        },
    },

    enumerators: {
        manageType: {
            admin: {
                label: "Admin",
                description: "Gestionar entidades",
            },
            property: {
                label: "Entidad",
                description: "Gestionar entidad",
            },
            subproperty: {
                label: "Subentidad",
                description: "Gestionar subentidad",
            },
            program: {
                label: "Programa",
                description: "Gestionar Programa",
            },
            subprogram: {
                label: "Subprograma",
                description: "Gestionar Subprograma",
            },
        },
        access: {
            public: 'Público',
            private: 'Privado',
        },
        country: {
            AD: "Andorra",
            AE: "United Arab Emirates",
            AF: "Afghanistan",
            AG: "Antigua and Barbuda",
            AI: "Anguilla",
            AL: "Albania",
            AM: "Armenia",
            AO: "Angola",
            AQ: "Antarctica",
            AR: "Argentina",
            AS: "American Samoa",
            AT: "Austria",
            AU: "Australia",
            AW: "Aruba",
            AX: "Åland Islands",
            AZ: "Azerbaijan",
            BA: "Bosnia and Herzegovina",
            BB: "Barbados",
            BD: "Bangladesh",
            BE: "Belgium",
            BF: "Burkina Faso",
            BG: "Bulgaria",
            BH: "Bahrain",
            BI: "Burundi",
            BJ: "Benin",
            BL: "Saint Barthélemy",
            BM: "Bermuda",
            BN: "Brunei Darussalam",
            BO: "Bolivia (Plurinational State of)",
            BQ: "Bonaire, Sint Eustatius and Saba",
            BR: "Brazil",
            BS: "Bahamas",
            BT: "Bhutan",
            BV: "Bouvet Island",
            BW: "Botswana",
            BY: "Belarus",
            BZ: "Belize",
            CA: "Canada",
            CC: "Cocos (Keeling) Islands",
            CD: "Congo, Democratic Republic of the",
            CF: "Central African Republic",
            CG: "Congo",
            CH: "Switzerland",
            CI: "Côte d'Ivoire",
            CK: "Cook Islands",
            CL: "Chile",
            CM: "Cameroon",
            CN: "China",
            CO: "Colombia",
            CR: "Costa Rica",
            CU: "Cuba",
            CV: "Cabo Verde",
            CW: "Curaçao",
            CX: "Christmas Island",
            CY: "Cyprus",
            CZ: "Czechia",
            DE: "Germany",
            DJ: "Djibouti",
            DK: "Denmark",
            DM: "Dominica",
            DO: "República Dominicana",
            DZ: "Algeria",
            EC: "Ecuador",
            EE: "Estonia",
            EG: "Egypt",
            EH: "Western Sahara",
            ER: "Eritrea",
            ES: "España",
            ET: "Ethiopia",
            FI: "Finland",
            FJ: "Fiji",
            FK: "Falkland Islands (Malvinas)",
            FM: "Micronesia (Federated States of)",
            FO: "Faroe Islands",
            FR: "France",
            GA: "Gabon",
            GB: "Reino Unido de Gran Bretaña e Irlanda del Norte",
            GD: "Grenada",
            GE: "Georgia",
            GF: "French Guiana",
            GG: "Guernsey",
            GH: "Ghana",
            GI: "Gibraltar",
            GL: "Greenland",
            GM: "Gambia",
            GN: "Guinea",
            GP: "Guadeloupe",
            GQ: "Equatorial Guinea",
            GR: "Greece",
            GS: "South Georgia and the South Sandwich Islands",
            GT: "Guatemala",
            GU: "Guam",
            GW: "Guinea-Bissau",
            GY: "Guyana",
            HK: "Hong Kong",
            HM: "Heard Island and McDonald Islands",
            HN: "Honduras",
            HR: "Croatia",
            HT: "Haiti",
            HU: "Hungary",
            ID: "Indonesia",
            IE: "Ireland",
            IL: "Israel",
            IM: "Isle of Man",
            IN: "India",
            IO: "British Indian Ocean Territory",
            IQ: "Iraq",
            IR: "Iran (Islamic Republic of)",
            IS: "Iceland",
            IT: "Italy",
            JE: "Jersey",
            JM: "Jamaica",
            JO: "Jordan",
            JP: "Japan",
            KE: "Kenya",
            KG: "Kyrgyzstan",
            KH: "Cambodia",
            KI: "Kiribati",
            KM: "Comoros",
            KN: "Saint Kitts and Nevis",
            KP: "Korea (Democratic People's Republic of)",
            KR: "Korea, Republic of",
            KW: "Kuwait",
            KY: "Cayman Islands",
            KZ: "Kazakhstan",
            LA: "Lao People's Democratic Republic",
            LB: "Lebanon",
            LC: "Saint Lucia",
            LI: "Liechtenstein",
            LK: "Sri Lanka",
            LR: "Liberia",
            LS: "Lesotho",
            LT: "Lithuania",
            LU: "Luxembourg",
            LV: "Latvia",
            LY: "Libya",
            MA: "Morocco",
            MC: "Monaco",
            MD: "Moldova, Republic of",
            ME: "Montenegro",
            MF: "Saint Martin (French part)",
            MG: "Madagascar",
            MH: "Marshall Islands",
            MK: "North Macedonia",
            ML: "Mali",
            MM: "Myanmar",
            MN: "Mongolia",
            MO: "Macao",
            MP: "Northern Mariana Islands",
            MQ: "Martinique",
            MR: "Mauritania",
            MS: "Montserrat",
            MT: "Malta",
            MU: "Mauritius",
            MV: "Maldives",
            MW: "Malawi",
            MX: "Mexico",
            MY: "Malaysia",
            MZ: "Mozambique",
            NA: "Namibia",
            NC: "New Caledonia",
            NE: "Niger",
            NF: "Norfolk Island",
            NG: "Nigeria",
            NI: "Nicaragua",
            NL: "Netherlands",
            NO: "Norway",
            NP: "Nepal",
            NR: "Nauru",
            NU: "Niue",
            NZ: "New Zealand",
            OM: "Oman",
            PA: "Panama",
            PE: "Peru",
            PF: "French Polynesia",
            PG: "Papua New Guinea",
            PH: "Philippines",
            PK: "Pakistan",
            PL: "Poland",
            PM: "Saint Pierre and Miquelon",
            PN: "Pitcairn",
            PR: "Puerto Rico",
            PS: "Palestine, State of",
            PT: "Portugal",
            PW: "Palau",
            PY: "Paraguay",
            QA: "Qatar",
            RE: "Réunion",
            RO: "Romania",
            RS: "Serbia",
            RU: "Russian Federation",
            RW: "Rwanda",
            SA: "Saudi Arabia",
            SB: "Solomon Islands",
            SC: "Seychelles",
            SD: "Sudan",
            SE: "Sweden",
            SG: "Singapore",
            SH: "Saint Helena, Ascension and Tristan da Cunha",
            SI: "Slovenia",
            SJ: "Svalbard and Jan Mayen",
            SK: "Slovakia",
            SL: "Sierra Leone",
            SM: "San Marino",
            SN: "Senegal",
            SO: "Somalia",
            SR: "Suriname",
            SS: "South Sudan",
            ST: "Sao Tome and Principe",
            SV: "El Salvador",
            SX: "Sint Maarten (Dutch part)",
            SY: "Syrian Arab Republic",
            SZ: "Eswatini",
            TC: "Turks and Caicos Islands",
            TD: "Chad",
            TF: "French Southern Territories",
            TG: "Togo",
            TH: "Thailand",
            TJ: "Tajikistan",
            TK: "Tokelau",
            TL: "Timor-Leste",
            TM: "Turkmenistan",
            TN: "Tunisia",
            TO: "Tonga",
            TR: "Turkey",
            TT: "Trinidad and Tobago",
            TV: "Tuvalu",
            TW: "Taiwan, Province of China",
            TZ: "Tanzania, United Republic of",
            UA: "Ukraine",
            UG: "Uganda",
            UM: "United States Minor Outlying Islands",
            US: "Estados Unidos de América",
            UY: "Uruguay",
            UZ: "Uzbekistan",
            VA: "Holy See",
            VC: "Saint Vincent and the Grenadines",
            VE: "Venezuela (Bolivarian Republic of)",
            VG: "Virgin Islands (British)",
            VI: "Virgin Islands (U.S.)",
            VN: "Viet Nam",
            VU: "Vanuatu",
            WF: "Wallis and Futuna",
            WS: "Samoa",
            YE: "Yemen",
            YT: "Mayotte",
            ZA: "South Africa",
            ZM: "Zambia",
            ZW: "Zimbabwe",
        },
        stateProvince: {
            CA: {
                'AB': 'Alberta',
                'BC': 'British Columbia',
                'MB': 'Manitoba',
                'NB': 'New Brunswick',
                'NT': 'Northwest Territories',
                'NL': 'Newfoundland and Labrador',
                'NS': 'Nova Scotia',
                'NU': 'Nunavut',
                'ON': 'Ontario',
                'PE': 'Prince Edward Island',
                'QC': 'Quebec',
                'SK': 'Saskatchewan',
                'YT': 'Yukon',
            },
            ES: {
                'C': 'La Coruña',
                'VI': 'Álava',
                'AB': 'Albacete',
                'A': 'Alicante',
                'AL': 'Almería',
                'O': 'Asturias',
                'AV': 'Ávila',
                'BA': 'Badajoz',
                'PM': 'Baleares',
                'B': 'Barcelona',
                'BI': 'Bizkaia',
                'BU': 'Burgos',
                'CC': 'Cáceres',
                'CA': 'Cádiz',
                'S': 'Cantabria',
                'CS': 'Castellón',
                'CE': 'Ceuta',
                'CR': 'Ciudad Real',
                'CO': 'Córdoba',
                'CU': 'Cuenca',
                'SS': 'Gipuzkoa',
                'GI': 'Gerona',
                'GR': 'Granada',
                'GU': 'Guadalajara',
                'H': 'Huelva',
                'HU': 'Huesca',
                'J': 'Jaén',
                'LO': 'La Rioja',
                'GC': 'Las Palmas',
                'LE': 'León',
                'L': 'Lérida',
                'LU': 'Lugo',
                'M': 'Madrid',
                'MA': 'Málaga',
                'ML': 'Melilla',
                'MU': 'Murcia',
                'NA': 'Navarra',
                'OR': 'Orense',
                'P': 'Palencia',
                'PO': 'Pontevedra',
                'SA': 'Salamanca',
                'TF': 'Santa Cruz de Tenerife',
                'SG': 'Segovia',
                'SE': 'Sevilla',
                'SO': 'Soria',
                'T': 'Tarragona',
                'TE': 'Teruel',
                'TO': 'Toledo',
                'V': 'Valencia',
                'VA': 'Valladolid',
                'ZA': 'Zamora',
                'Z': 'Zaragoza',
            },
            US: {
                'AL': 'Alabama',
                'AK': 'Alaska',
                'AZ': 'Arizona',
                'AR': 'Arkansas',
                'CA': 'California',
                'CO': 'Colorado',
                'CT': 'Connecticut',
                'DE': 'Delaware',
                'FL': 'Florida',
                'GA': 'Georgia',
                'HI': 'Hawaii',
                'ID': 'Idaho',
                'IL': 'Illinois',
                'IN': 'Indiana',
                'IA': 'Iowa',
                'KS': 'Kansas',
                'KY': 'Kentucky',
                'LA': 'Louisiana',
                'ME': 'Maine',
                'MD': 'Maryland',
                'MA': 'Massachusetts',
                'MI': 'Michigan',
                'MN': 'Minnesota',
                'MS': 'Mississippi',
                'MO': 'Missouri',
                'MT': 'Montana',
                'NE': 'Nebraska',
                'NV': 'Nevada',
                'NH': 'New Hampshire',
                'NJ': 'New Jersey',
                'NM': 'New Mexico',
                'NY': 'New York',
                'NC': 'North Carolina',
                'ND': 'North Dakota',
                'OH': 'Ohio',
                'OK': 'Oklahoma',
                'OR': 'Oregon',
                'PA': 'Pennsylvania',
                'RI': 'Rhode Island',
                'SC': 'South Carolina',
                'SD': 'South Dakota',
                'TN': 'Tennessee',
                'TX': 'Texas',
                'UT': 'Utah',
                'VT': 'Vermont',
                'VA': 'Virginia',
                'WA': 'Washington',
                'WV': 'West Virginia',
                'WI': 'Wisconsin',
                'WY': 'Wyoming',
            },
        },
        soccerFormat: {
            'f7': 'Fútbol 7',
            'f11': 'Fútbol 11',
        },
        clubType: {
            federated: 'Federado en España',
            federatedForeign: 'Federado fuera de España',
            nonFederated: 'No Federado',
            academy: 'Academia',
            nationalTeam: 'Selección',
            other: 'Otro',
        },
        clubFederation: {
            'AN': 'Andalucía',
            'AR': 'Aragón',
            'AS': 'Asturias, Principado de',
            'CN': 'Canarias',
            'CB': 'Cantabria',
            'CL': 'Castilla y León',
            'CM': 'Castilla-La Mancha',
            'CT': 'Cataluña',
            'CE': 'Ceuta',
            'EX': 'Extremadura',
            'GA': 'Galicia',
            'IB': 'Islas Baleares',
            'RI': 'La Rioja',
            'MD': 'Madrid, Comunidad de',
            'ML': 'Melilla',
            'MC': 'Murcia, Región de',
            'NC': 'Navarra, Comunidad Foral de',
            'PV': 'País Vasco',
            'VC': 'Valenciana, Comunidad',
        },
        clubKitPieceType: {
            solid: 'Lisa',
            striped: 'Rayas',
            checkered: 'Cuadros',
            band: 'Banda',
        },
        mcc: {
            '7032': '(7032) Sporting / Recreation Camps',
            '7941': '(7941) Sports Clubs / Fields',
            '8211': '(8211) Elementary, Secondary Schools',
            '8220': '(8220) Colleges, Universities',
            '8299': '(8299) Educational Services',
            '8699': '(8699) Membership Organizations',
        },
        currency: {
            'aed': 'AED - United Arab Emirates dirham',
            'afn': 'AFN - Afghan afghani',
            'all': 'ALL - Albanian lek',
            'amd': 'AMD - Armenian dram',
            'ang': 'ANG - Netherlands Antillean guilder',
            'aoa': 'AOA - Angolan kwanza',
            'ars': 'ARS - Argentine peso',
            'aud': 'AUD - Australian dollar',
            'awg': 'AWG - Aruban florin',
            'azn': 'AZN - Azerbaijani manat',
            'bam': 'BAM - Bosnia and Herzegovina convertible mark',
            'bbd': 'BBD - Barbados dollar',
            'bdt': 'BDT - Bangladeshi taka',
            'bgn': 'BGN - Bulgarian lev',
            'bhd': 'BHD - Bahraini dinar',
            'bif': 'BIF - Burundian franc',
            'bmd': 'BMD - Bermudian dollar',
            'bnd': 'BND - Brunei dollar',
            'bob': 'BOB - Boliviano',
            'bov': 'BOV - Bolivian Mvdol',
            'brl': 'BRL - Brazilian real',
            'bsd': 'BSD - Bahamian dollar',
            'btn': 'BTN - Bhutanese ngultrum',
            'bwp': 'BWP - Botswana pula',
            'byn': 'BYN - Belarusian ruble',
            'bzd': 'BZD - Belize dollar',
            'cad': 'CAD - Canadian dollar',
            'cdf': 'CDF - Congolese franc',
            'che': 'CHE - WIR Euro',
            'chf': 'CHF - Swiss franc',
            'chw': 'CHW - WIR Franc',
            'clf': 'CLF - Unidad de Fomento',
            'clp': 'CLP - Chilean peso',
            'cny': 'CNY - Renminbi (Chinese) yuan',
            'cop': 'COP - Colombian peso',
            'cou': 'COU - Unidad de Valor Real (UVR)',
            'crc': 'CRC - Costa Rican colon',
            'cuc': 'CUC - Cuban convertible peso',
            'cup': 'CUP - Cuban peso',
            'cve': 'CVE - Cape Verdean escudo',
            'czk': 'CZK - Czech koruna',
            'djf': 'DJF - Djiboutian franc',
            'dkk': 'DKK - Danish krone',
            'dop': 'DOP - Dominican peso',
            'dzd': 'DZD - Algerian dinar',
            'egp': 'EGP - Egyptian pound',
            'ern': 'ERN - Eritrean nakfa',
            'etb': 'ETB - Ethiopian birr',
            'eur': 'EUR - Euro',
            'fjd': 'FJD - Fiji dollar',
            'fkp': 'FKP - Falkland Islands pound',
            'gbp': 'GBP - Pound sterling',
            'gel': 'GEL - Georgian lari',
            'ghs': 'GHS - Ghanaian cedi',
            'gip': 'GIP - Gibraltar pound',
            'gmd': 'GMD - Gambian dalasi',
            'gnf': 'GNF - Guinean franc',
            'gtq': 'GTQ - Guatemalan quetzal',
            'gyd': 'GYD - Guyanese dollar',
            'hkd': 'HKD - Hong Kong dollar',
            'hnl': 'HNL - Honduran lempira',
            'hrk': 'HRK - Croatian kuna',
            'htg': 'HTG - Haitian gourde',
            'huf': 'HUF - Hungarian forint',
            'idr': 'IDR - Indonesian rupiah',
            'ils': 'ILS - Israeli new shekel',
            'inr': 'INR - Indian rupee',
            'iqd': 'IQD - Iraqi dinar',
            'irr': 'IRR - Iranian rial',
            'isk': 'ISK - Icelandic króna',
            'jmd': 'JMD - Jamaican dollar',
            'jod': 'JOD - Jordanian dinar',
            'jpy': 'JPY - Japanese yen',
            'kes': 'KES - Kenyan shilling',
            'kgs': 'KGS - Kyrgyzstani som',
            'khr': 'KHR - Cambodian riel',
            'kmf': 'KMF - Comoro franc',
            'kpw': 'KPW - North Korean won',
            'krw': 'KRW - South Korean won',
            'kwd': 'KWD - Kuwaiti dinar',
            'kyd': 'KYD - Cayman Islands dollar',
            'kzt': 'KZT - Kazakhstani tenge',
            'lak': 'LAK - Lao kip',
            'lbp': 'LBP - Lebanese pound',
            'lkr': 'LKR - Sri Lankan rupee',
            'lrd': 'LRD - Liberian dollar',
            'lsl': 'LSL - Lesotho loti',
            'lyd': 'LYD - Libyan dinar',
            'mad': 'MAD - Moroccan dirham',
            'mdl': 'MDL - Moldovan leu',
            'mga': 'MGA - Malagasy ariary',
            'mkd': 'MKD - Macedonian denar',
            'mmk': 'MMK - Myanmar kyat',
            'mnt': 'MNT - Mongolian tögrög',
            'mop': 'MOP - Macanese pataca',
            'mru': 'MRU - Mauritanian ouguiya',
            'mur': 'MUR - Mauritian rupee',
            'mvr': 'MVR - Maldivian rufiyaa',
            'mwk': 'MWK - Malawian kwacha',
            'mxn': 'MXN - Mexican peso',
            'mxv': 'MXV - Mexican Unidad de Inversion (UDI)',
            'myr': 'MYR - Malaysian ringgit',
            'mzn': 'MZN - Mozambican metical',
            'nad': 'NAD - Namibian dollar',
            'ngn': 'NGN - Nigerian naira',
            'nio': 'NIO - Nicaraguan córdoba',
            'nok': 'NOK - Norwegian krone',
            'npr': 'NPR - Nepalese rupee',
            'nzd': 'NZD - New Zealand dollar',
            'omr': 'OMR - Omani rial',
            'pab': 'PAB - Panamanian balboa',
            'pen': 'PEN - Peruvian sol',
            'pgk': 'PGK - Papua New Guinean kina',
            'php': 'PHP - Philippine peso',
            'pkr': 'PKR - Pakistani rupee',
            'pln': 'PLN - Polish złoty',
            'pyg': 'PYG - Paraguayan guaraní',
            'qar': 'QAR - Qatari riyal',
            'ron': 'RON - Romanian leu',
            'rsd': 'RSD - Serbian dinar',
            'rub': 'RUB - Russian ruble',
            'rwf': 'RWF - Rwandan franc',
            'sar': 'SAR - Saudi riyal',
            'sbd': 'SBD - Solomon Islands dollar',
            'scr': 'SCR - Seychelles rupee',
            'sdg': 'SDG - Sudanese pound',
            'sek': 'SEK - Swedish krona/kronor',
            'sgd': 'SGD - Singapore dollar',
            'shp': 'SHP - Saint Helena pound',
            'sll': 'SLL - Sierra Leonean leone',
            'sos': 'SOS - Somali shilling',
            'srd': 'SRD - Surinamese dollar',
            'ssp': 'SSP - South Sudanese pound',
            'stn': 'STN - São Tomé and Príncipe dobra',
            'svc': 'SVC - Salvadoran colón',
            'syp': 'SYP - Syrian pound',
            'szl': 'SZL - Swazi lilangeni',
            'thb': 'THB - Thai baht',
            'tjs': 'TJS - Tajikistani somoni',
            'tmt': 'TMT - Turkmenistan manat',
            'tnd': 'TND - Tunisian dinar',
            'top': 'TOP - Tongan paʻanga',
            'try': 'TRY - Turkish lira',
            'ttd': 'TTD - Trinidad and Tobago dollar',
            'twd': 'TWD - New Taiwan dollar',
            'tzs': 'TZS - Tanzanian shilling',
            'uah': 'UAH - Ukrainian hryvnia',
            'ugx': 'UGX - Ugandan shilling',
            'usd': 'USD - United States dollar',
            'usn': 'USN - United States dollar (next day)',
            'uyi': 'UYI - Uruguay Peso en Unidades Indexadas (URUIURUI)',
            'uyu': 'UYU - Uruguayan peso',
            'uyw': 'UYW - Unidad previsional',
            'uzs': 'UZS - Uzbekistan som',
            'ves': 'VES - Venezuelan bolívar soberano',
            'vnd': 'VND - Vietnamese đồng',
            'vuv': 'VUV - Vanuatu vatu',
            'wst': 'WST - Samoan tala',
            'xaf': 'XAF - CFA franc BEAC',
            'xag': 'XAG - Silver (one troy ounce)',
            'xau': 'XAU - Gold (one troy ounce)',
            'xba': 'XBA - European Composite Unit (EURCO)',
            'xbb': 'XBB - European Monetary Unit (E.M.U.-6)',
            'xbc': 'XBC - European Unit of Account 9 (E.U.A.-9)',
            'xbd': 'XBD - European Unit of Account 17 (E.U.A.-17)',
            'xcd': 'XCD - East Caribbean dollar',
            'xdr': 'XDR - Special drawing rights',
            'xof': 'XOF - CFA franc BCEAO',
            'xpd': 'XPD - Palladium (one troy ounce)',
            'xpf': 'XPF - CFP franc (franc Pacifique)',
            'xpt': 'XPT - Platinum (one troy ounce)',
            'xsu': 'XSU - SUCRE',
            'xts': 'XTS - Code reserved for testing',
            'xua': 'XUA - ADB Unit of Account',
            'xxx': 'XXX - No currency',
            'yer': 'YER - Yemeni rial',
            'zar': 'ZAR - South African rand',
            'zmw': 'ZMW - Zambian kwacha',
            'zwl': 'ZWL - Zimbabwean dollar',
        },
        businessType: {
            individual: 'Individual',
            company: 'Empresa',
        },
        subpropertyStatus: {
            enabled: "Activo",
            disabled: "Inactivo"
        },
        gender: {
            'male': 'Masculino',
            'female': 'Femenino',
            'mixed': 'Mixto',
        },
        genderBinary: {
            'male': 'Masculino',
            'female': 'Femenino',
        },
        programType: {
            'all': 'All',
            'club': 'Club',
            'school': 'Formación',
            'campclinics': 'Campus & Clinics',
            'league': 'Liga',
            'tournament': 'Torneo',
        },
        programStatus: {
            "draft": "Borrador",
            "published": "Publicado",
            "regOpened": "Registro abierto",
            "regClosed": "Registro cerrado",
            "archived": "Archivado"
        },
        propertyType: {
            'academyclub': 'Academia & Club',
            'league': 'Liga',
            'tournament': 'Torneo',
            'nba': 'NBA',
        },
        propertyStatus: {
            enabled: "Activa",
            disabled: "Inactiva"
        },
        sport: {
            'basketball': 'Baloncesto',
            'soccer': 'Fútbol',
        },
        subprogramStatus: {
            "draft": "En borrador",
            "published": "Publicado",
            "comingSoon": "Registro próximamente",
            "regOpened": "Registro abierto",
            "regClosed": "Registro cerrado",
            "archived": "Archivado"
        },
        inscriptionStatus: {
            'all': 'Todos',
            'pendingApproval': "Pendiente de aprobación",
            'onWaitingList': "En lista de espera",
            'onTryout': "En prueba",
            'approved': "Aprobada",
            'pendingPayment': "Pendiente de pago",
            'paid': "Pagada",
            'reject': "Cancelado",
        },
        payoutObjectType: {
            bank_account: 'Cuenta bancaria',
            card: 'Tarjeta'
        },
        payoutStatus: {
            paid: "Pagado",
            pending: "Pendiente",
            in_transit: "En camino",
            canceled: "Cancelado",
            failed: "Denegado",
        },
        chargeType: {
            oneTime: 'Pago único',
            installment: 'A cuotas',
            subscription: 'Suscripción',
        },
        chargeStatus: {
            succeeded: 'Aprobado',
            pending: 'Pendiente',
            failed: 'Denegado',
        },
        stripePayoutsScheduleInterval: {
            daily: 'Cada día',
            weekly: 'Cada semana',
            monthly: 'Cada mes'
        },
        weekDay: {
            monday: 'Lunes',
            tuesday: 'Martes',
            wednesday: 'Miércoles',
            thursday: 'Jueves',
            friday: 'Viernes',
            saturday: 'Sábado',
            sunday: 'Domingo'
        },
        monthDay: {
            1: 'Día 1',
            2: 'Día 2',
            3: 'Día 3',
            4: 'Día 4',
            5: 'Día 5',
            6: 'Día 6',
            7: 'Día 7',
            8: 'Día 8',
            9: 'Día 9',
            10: 'Día 10',
            11: 'Día 11',
            12: 'Día 12',
            13: 'Día 13',
            14: 'Día 14',
            15: 'Día 15',
            16: 'Día 16',
            17: 'Día 17',
            18: 'Día 18',
            19: 'Día 19',
            20: 'Día 20',
            21: 'Día 21',
            22: 'Día 22',
            23: 'Día 23',
            24: 'Día 24',
            25: 'Día 25',
            26: 'Día 26',
            27: 'Día 27',
            28: 'Día 28',
            29: 'Día 29',
            30: 'Día 30',
            31: 'Día 31',
        },
        stripePersonVerification: {
            unverified: "No verificado",
            pending: "Pendiente",
            verified: "Verificado",
            failed: "Fallido",
            incomplete: "Incompleto",
        },
        externalAccountStatus: {
            new: 'Nuevo',
            validated: 'Validado',
            verified: 'Verificado',
            verification_failed: 'Fallo en la verificación',
            errored: 'Fallido',
        },
        coachType: {
            coachHead: 'Entrenador principal',
            coachDirector: 'Director de Tecnificación',
            coach: 'Entrenador',
            coachAssistant: 'Segundo entrenador',
            schoolManager: 'Manager de la escuela',
            teamManager: 'Manager del equipo'
        },
        birthdateType: {
            year: 'Por año',
            monthAndYear: 'Por mes y año',
        },
        dateFormat: {
            'dd/MM/yyyy': 'dd/mm/yyyy',
            'MM/dd/yyyy': 'mm/dd/yyyy',
        },
        timeFormat: {
            'hh:mm a': '12h (AM/PM)',
            'HH:mm': '24h',
        },
        gameStatus: {
            'toPlay': 'Por jugar',
            'toBeConfirmed': 'Por confirmar',
            'disputedResult': 'En disputa',
            'played': 'Jugado'
        },
        gameType: {
            'groups': 'Grupo',
            'playoffs': 'Eliminatoria',
        },
    },

    auth: {
        profile: {
            title: 'Editar Perfil',
            success: 'Profile updated successfully',
        },
        createAnAccount: 'Crear una cuenta',
        createYourAccount: 'Crea tu cuenta',
        rememberMe: 'Recordarme',
        noAccountYet: '¿No tienes cuenta aún?',
        forgotPassword: {
            message: '¿Has olvidado la contraseña?',
            error: {
                'email/unknown': 'No existe ninguna cuenta con este correo electrónico',
            },
        },
        login: 'Iniciar Sesión',
        signin: 'Iniciar Sesión',
        signup: 'Registrarse',
        signupText: 'Crear cuenta',
        signout: 'Cerrar sesión',
        alreadyHaveAnAccount: '¿Ya tienes una cuenta?',
        signinWithAnotherAccount: 'Entrar con otra cuenta',
        emailUnverified: {
            welcome: `Bienvenido a <strong>{0}</strong>`,
            message: `Porfavor confirma tu correo <strong>{0}</strong> para continuar.`,
            submit: `Reenviar correo de verificación`,
        },
        emptyPermissions: {
            title: `¡Ya formas parte de <strong>OWQLO! </strong>`,
            message: `Descárgate la app y empieza a disfrutar.`,
        },
        dynamicLink: {
            title: `¡Ya casi estás en <strong>OWQLO!</strong>`,
            first: 'Vuelve a abrir este enlace desde tu móvil',
            second: 'Descarga la app',
            third: 'Empieza a disfrutar'
        }, 
        passwordResetEmail: {
            message: 'Recuperar contraseña',
            error: `Email no encontrado`,
            success: {
                title: 'Email enviado',
                message: 'Te hemos enviado un email con los pasos a seguir para recuperar tu contraseña.',
                buttonCaption: 'Go to home',
            },
        },
        passwordReset: {
            message: 'Reset password',
            title: 'Contraseña restablecida con éxito',
            first: 'Abre la app',
            second: 'Inicie sesión con su nueva contraseña',
            third: '¡Disfruta descubriendo nuestra app!'
        },
        emailVerification: {
            title: 'Email verificado con éxito',
            first: 'Abre la app',
            second: 'Inicie sesión',
            third: 'Disfruta descubriendo nuestra app!'
        },
        emailAddressVerificationEmail: {
            error: `Email not recognized`,
        },
        verificationEmailSuccess: `Verification email sent successfully`,
        passwordResetEmailSuccess: `Password reset email sent successfully`,
        passwordResetSuccess: `Password changed successfully`,
        verifyEmail: {
            success: 'Email successfully verified',
            message: 'Just a moment, your email is being verified...',
        },
        passwordAgain: 'Por favor ingrese la contraseña de nuevo',
        passwordNotMatch: 'La contraseña no coincide!',
        fields: {
            email: 'Email',
            password: 'Contraseña',
            confirmPassword: 'Confirmar contraseña',
            rememberMe: 'Recuerdame'
        }
    },

    roles: {
        admin: {
            label: 'Owner',
            description: 'Full access to all resources',
        },
        subpropertyManager: {
            label: 'Administrador', // TODO:es
            description: 'Full access to all resources',
        },
        propertyManager: {
            label: 'Administrador', // TODO:es
            description: 'Full access to all resources',
        },
        editor: {
            label: 'Editor',
            description: 'Editar access to all resources',
        },
        viewer: {
            label: 'Viewer',
            description: 'Ver access to all resources',
        },
        auditLogViewer: {
            label: 'Audit Log Viewer',
            description: 'Acceso to view audit logs',
        },
        iamSecurityReviewer: {
            label: 'Security Reviewer',
            description: `Full access to manage users roles`,
        },
        entityEditor: {
            label: 'Entity Editor',
            description: 'Editar access to all entities',
        },
        entityViewer: {
            label: 'Entity Viewer',
            description: 'Ver access to all entities',
        },
        academyEditor: {
            label: 'Academia Editor',
            description: 'Editar access to academies',
        },
        academyViewer: {
            label: 'Academia Viewer',
            description: 'Ver access to academies',
        },
        playerEditor: {
            label: 'Jugador Editor',
            description: 'Editar access to players',
        },
        playerViewer: {
            label: 'Jugador Viewer',
            description: 'Ver access to players',
        },
        propertySettingEditor: {
            label: 'PropertySetting Editor',
            description: 'Editar access to propertySettings',
        },
        propertySettingViewer: {
            label: 'PropertySetting Viewer',
            description: 'Ver access to propertySettings',
        },
        coachEditor: {
            label: 'Entrenador Editor',
            description: 'Editar access to coaches',
        },
        coachViewer: {
            label: 'Entrenador Viewer',
            description: 'Ver access to coaches',
        },
        parentEditor: {
            label: 'Padres Editor',
            description: 'Editar access to parents',
        },
        parentViewer: {
            label: 'Padres Viewer',
            description: 'Ver access to parents',
        },
        newsEditor: {
            label: 'Noticias Editor',
            description: 'Editar access to news',
        },
        newsViewer: {
            label: 'Noticias Viewer',
            description: 'Ver access to news',
        },
        trainingEditor: {
            label: 'Entrenamiento Editor',
            description: 'Editar access to trainings',
        },
        trainingViewer: {
            label: 'Entrenamiento Viewer',
            description: 'Ver access to trainings',
        },
        gameEditor: {
            label: 'Partido Editor',
            description: 'Editar access to games',
        },
        gameViewer: {
            label: 'Partido Viewer',
            description: 'Ver access to games',
        },
        eventEditor: {
            label: 'Evento Editor',
            description: 'Editar access to events',
        },
        eventViewer: {
            label: 'Evento Viewer',
            description: 'Ver access to events',
        },
        teamEditor: {
            label: 'Equipo Editor',
            description: 'Editar access to teams',
        },
        teamViewer: {
            label: 'Equipo Viewer',
            description: 'Ver access to teams',
        },
        positionEditor: {
            label: 'Position Editor',
            description: 'Editar access to positions',
        },
        positionViewer: {
            label: 'Position Viewer',
            description: 'Ver access to positions',
        },
        fanEditor: {
            label: 'Fan Editor',
            description: 'Editar access to fans',
        },
        fanViewer: {
            label: 'Fan Viewer',
            description: 'Ver access to fans',
        },
        sheetEventEditor: {
            label: 'SheetEvent Editor',
            description: 'Editar access to sheetEvents',
        },
        sheetEventViewer: {
            label: 'SheetEvent Viewer',
            description: 'Ver access to sheetEvents',
        },
        siteEditor: {
            label: 'Site Editor',
            description: 'Editar access to sites',
        },
        siteViewer: {
            label: 'Site Viewer',
            description: 'Ver access to sites',
        },
        clubEditor: {
            label: 'Club Editor',
            description: 'Editar access to clubs',
        },
        clubViewer: {
            label: 'Club Viewer',
            description: 'Ver access to clubs',
        },
        serviceEditor: {
            label: 'Service Editor',
            description: 'Editar access to services',
        },
        serviceViewer: {
            label: 'Service Viewer',
            description: 'Ver access to services',
        },
        propertyEditor: {
            label: 'Entidad Editor',
            description: 'Editar access to properties',
        },
        propertyViewer: {
            label: 'Entidad Viewer',
            description: 'Ver access to properties',
        },
        categoryEditor: {
            label: 'Categoría Editor',
            description: 'Editar access to categories',
        },
        categoryViewer: {
            label: 'Categoría Viewer',
            description: 'Ver access to categories',
        },
        programEditor: {
            label: 'Programa Editor',
            description: 'Editar access to programs',
        },
        programViewer: {
            label: 'Programa Viewer',
            description: 'Ver access to programs',
        },
        subprogramEditor: {
            label: 'Subprograma Editor',
            description: 'Editar access to subprograms',
        },
        subprogramViewer: {
            label: 'Subprograma Viewer',
            description: 'Ver access to subprograms',
        },
    },

    programs: {
        tournament: {
            label: 'Torneo',
            description: 'Descripción de Torneo',
            new: 'Crear Torneo',
            empty: 'No hay torneos aún',
        },
        club: {
            label: 'Club',
            description: 'Descripción de Club',
            new: 'Crear Club',
            empty: 'No hay clubs aún',
        },
        school: {
            label: 'Formación',
            description: 'Descripción de Formación',
            new: 'Crear Formación',
            empty: 'No hay formaciones aún',
        },
        campclinics: {
            label: 'Campus & Clinics',
            description: 'Descripción de Campus & Clinics',
            new: 'Crear Campus & Clinics',
            empty: 'No hay campues & clinics aún',
        },
        league: {
            label: 'Liga',
            menu: 'Ligas',
            description: 'Descripción de Liga',
            new: 'Crear Liga',
            edit: 'Editar Liga',
            empty: 'No hay ligas aún',
        },
    },

    iam: {
        title: 'Gestión de usuarios',
        menu: 'Gestión de usuarios',
        disable: 'Desactivar',
        disabled: 'Desactivar',
        enabled: 'Activar',
        enable: 'Activar',
        doEnableSuccess: 'User enabled successfully',
        doDisableSuccess: 'User disabled successfully',
        doDisableAllSuccess: 'User(s) disabled successfully',
        doEnableAllSuccess: 'User(s) enabled successfully',
        doAddSuccess: 'User(s) se ha guardado correctamente',
        doUpdateSuccess: 'User se ha guardado correctamente',
        viewBy: 'Ver By',
        users: {
            name: 'users',
            label: 'Users',
            exporterFileName: 'users_export',
            doRemoveAllSelectedSuccess: 'Permissions removed successfully',
        },
        managers: {
            empty: 'No hay gestores aún',
        },
        roles: {
            label: 'Roles',
            doRemoveAllSelectedSuccess: 'Permissions removed successfully',
        },

        edit: {
            title: 'Editar Usuario',
        },
        new: {
            title: 'Nuevo Usuario',
            emailsHint: 'Separate multiple email addresses using the comma character.',
        },
        newManager: {
            title: 'Nuevo Manager'
        },
        view: {
            title: 'Ver User',
            activity: 'Actividad',
        },
        importer: {
            title: 'Importar Users',
            fileName: 'users_import_template',
            hint: 'Files/Images columns must be the URLs of the files separated by space. Relationships must be the ID of the referenced records separated by space. Roles must be the role ids separated by space.',
        },
        errors: {
            userAlreadyExists: 'User with this email already exists',
            userNotFound: 'User not found',
            emailNotFound: 'El email no existe',
            disablingHimself: `You can't disabled yourself`,
            revokingOwnPermission: `You can't revoke your own admin permission`,
        },
        placeholders: {
            roles: 'Selecciona uno...',
            email: 'email@dominio.com'
        }
    },

    staff: {
        title: 'Staff',
        menu: 'Staff',
        tabs: {
            managers: 'Gestores',
            coaches: 'Entrenadores'
        }
    },

    user: {
        fields: {
            id: 'Id',
            authenticationUid: 'Authentication Uid',
            avatars: 'Foto de perfil',
            email: 'Email',
            emails: 'Email(s)',
            fullName: 'Nombre',
            firstName: 'Nombre',
            lastName: 'Apellido(s)',
            gender: 'Sexo',
            birthdate: 'Fecha de nacimiento',
            status: 'Estado',
            disabled: 'Inactivo',
            phoneNumber: 'Teléfono',
            role: 'Role',
            lastLogin: 'Última conexión',
            createdAt: 'Creado en',
            updatedAt: 'Actualizado en',
            roleUser: 'Role/User',
            roles: 'Roles',
            manageType: 'Nivel de gestión',
            admin: 'Administrador',
            property: 'Entidad',
            subproperty: 'Subentidad',
            program: 'Programa',
            subprogram: 'Subprograma',
            createdAtRange: 'Creado en',
            password: 'Contraseña',
            confirmPassword: {
                label: 'Confirmar contraseña',
                validation: {
                    notEqual: 'Las contraseñas no coinciden',
                },
            },
            rememberMe: 'Recordarme',
            tosAccepted: {
                label: 'He leído y acepto ${linkTerms} y ${linkPrivacy}',
                linkCaptionPrivacy: 'Política de privacidad',
                linkHrefPrivacy: 'https://owqlo.com/politica-de-privacidad/',
                linkCaptionTerms: 'Términos y condiciones',
                linkHrefTerms: 'https://owqlo.com/terminos-y-condiciones/',
                validation: 'Es necesario que leas y aceptes las condiciones de arriba',
            },
            inscriptionTutorConfirmed: {
                label: 'Confirmo que soy padre o madre de los jugadores registrados.',
                validation: 'Es necesario que aceptes las condiciones de más arriba',
            },
            'identDoc': 'Número de ID',
        },
        placeholders: {
            firstName: 'Mateo',
            lastName: 'Rodríguez',
            gender: 'Elige uno',
            birthdate: 'yyyy-mm-dd',
            phoneNumber: '+34612345678',
            email: 'email@dominio.com',
            password: '********',
            confirmPassword: '********',
        },
        form: {
            subtitle: {
                parentInfo: 'Información del padre / madre',
                parentAddress: 'Dirección del padre / madre',
            },
            tooltip: {
                emailDisabled: 'Por motivos de privacidad no podemos modificar el correo electrónico',
            }
        },
        enabled: 'Autorizado',
        disabled: 'No autorizado',
        validations: {
            email: 'El email no es válido',
            url: 'La URL no es válida',
            phone: 'El teléfono no es válido',
        },

    },

    auditLog: {
        menu: 'Registro de actividad',
        title: 'Registro de actividad',
        exporterFileName: 'audit_log_export',
        entityNamesHint: 'Separate multiple entities using the comma character.',
        fields: {
            id: 'Id',
            timestampRange: 'Period',
            entityName: 'Entity',
            entityNames: 'Entities',
            entityId: 'Entity ID',
            action: 'Action',
            values: 'Values',
            timestamp: 'Date',
            createdByEmail: 'User Email',
        },
    },
    adminSettings: {
        title: 'Ajustes',
        menu: 'Ajustes',
        save: {
            success: 'Ajustes guardados correctamente. La página se refrescará en {0} segundos para que se efectuen los cambios.',
        },
        fields: {
            theme: 'Theme',
        },
        colors: {
            default: 'Default',
            cyan: 'Cyan',
            'geek-blue': 'Geek Blue',
            gold: 'Gold',
            lime: 'Lime',
            magenta: 'Magenta',
            orange: 'Orange',
            'polar-green': 'Polar Green',
            purple: 'Purple',
            red: 'Red',
            volcano: 'Volcano',
            yellow: 'Yellow',
        },
    },
    propertySettings: {
        title: 'Configuración de la entidad',
        menu: 'Configuración de la entidad',
    },
    subpropertySettings: {
        title: 'Ajustes',
        menu: 'Ajustes',
        information: 'Aquí iría un copy que aún no se ha definido. Para explicar que estos campos son configurables por el administrador, es decir, están creando información predeterminada.',
        program: {
            title: 'Configuración de programas',
            subtitle: 'Rellena la información necesaria',
            tooltipCaption: 'Desde este apartado podrás crear todos los contenidos necesarios para poder crear un programa.',
        },
        finantial: {
            title: 'Configuración bancaria',
            subtitle: 'Cuentas, Métodos de retirada, Calendario de pagos',
            tooltipCaption: 'Desde este apartado podrás gestionar todo lo relaciondo con tu cuenta financiera de la subproperty.',
            accountTab: 'Cuentas',
            payoutMethodsTab: 'Métodos de retirada',
            payoutScheduleTab: 'Calendario de pagos',
            othersTab: 'Otros',
            accounts: {
                emptyAccountText: 'No hay cuentas conectadas',
                emptyPersonText: 'No hay personas asociadas aún',
                emptyAccountButton: 'Añadir cuentas conectadas',
                emptyPersonButton: 'Añadir personas asociadas',
                subtitle: {
                    connectedAccount: 'Cuenta asociada',
                    additionalQuestions: 'Preguntas adicionales',
                    connectedPersons: 'Personas asociadas',
                },
                payments: 'Pagos',
                payouts: 'Retiradas de fondos',
                deleteText: 'Si quieres borrar alguna cuenta asociada o persona asociada, por favor ponte en contacto con',
                disabledReason: {
                    'listed': 'Algunas de las características de la cuenta están desactivadas porque podría estar en una lista de personas o empresas prohibidas (gestionada por Stripe).',
                    'under_review': 'Algunas de las características de la cuenta están deshabilitadas porque Stripe está revisando la misma.',
                    'other': 'Algunas de las características de la cuenta están desactivadas por una razón desconocida. Por favor, contacte con <a href="mailto:support@owqlo.com" target="_blank">support@owqlo.com</a>',
                    requirements: {
                        'past_due': 'Algunas de las características de la cuenta están desactivadas porque algunos requisitos han vencido.',
                        'pending_verification': 'Algunas de las características de la cuenta están desactivadas porque el proceso de verificación está pendiente / en curso.',
                    },
                    rejected: {
                        'fraud': 'Su cuenta ha sido rechazada debido a la sospecha de fraude o actividad ilegal. Por favor, contacte con <a href="mailto:support@owqlo.com" target="_blank">support@owqlo.com</a>',
                        'terms_of_service': 'Su cuenta ha sido rechazada debido a un conflicto con los Términos y Condiciones de Stripe. Por favor, contacte con <a href="mailto:support@owqlo.com" target="_blank">support@owqlo.com</a>',
                        'listed': 'Su cuenta ha sido rechazada porque se encuentra en una lista de personas o empresas prohibidas (gestionada por Stripe). Por favor, contacte con <a href="mailto:support@owqlo.com" target="_blank">support@owqlo.com</a>',
                        'other': 'Su cuenta ha sido rechazada por alguna razón desconocida. Por favor, contacte con <a href="mailto:support@owqlo.com" target="_blank">support@owqlo.com</a>',
                    },
                },
                requirements: {
                    titles: {
                        dueRequirements: 'Los requisitos necesarios son:',
                        currentlyVerifying: 'Actualmente verificando:',
                        personRequirements: 'Hay requisitos relacionados con personas; revisa la lista de personas abajo.',
                    },
                    relationship: {
                        owner: 'Añade todos los propietarios (25% o más de participación)',
                        director: 'Añade todos los directores',
                        representative: 'Añade un Representante',
                        account_opener: 'Añade un Representante',
                        title: 'Cargo requerido',
                        executive: 'El representante también debe ser un ejecutivo y/o un propietario',
                    },
                    address: {
                        city: 'Dirección: Ciudad requerida',
                        line1: 'Dirección: Línea 1 requerida',
                        postal_code: 'Dirección: ZIP / Código Postal requerido',
                        state: 'Dirección: Estado requerido',
                    },
                    dob: {
                        day: 'Fecha de nacimiento: Día requerido',
                        month: 'Fecha de nacimiento: Mes requerido',
                        year: 'Fecha de nacimiento: Año requerido',
                    },
                    business_profile: {
                        mcc: 'Código de Categoría Mercante (MCC) requerido',
                    },
                    verification: {
                        document: 'Documentos de identidad requeridos',
                        additional_document: 'Documentos adicionales requeridos',
                    },
                    company: {
                        verification: {
                            document: 'Documentos de empresa requeridos',
                            additional_document: 'Documentos de empresa adicionales requeridos',
                        },
                    },
                    email: 'Correo electrónico requerido',
                    phone: 'Número de teléfono requerido',
                    ssn_last_4: 'Cuatro últimos dígitos del SSN requeridos',
                    external_account: 'Configura un Método de Retirada de fondos',
                },
            },
            questions: {
                relationship: {
                    director: '¿Alguien más actúa como director de {0}?',
                    owner: '¿Alguien más actúa como propietario de {0}?',
                    executive: '¿Alguien más actúa como ejecutivo de {0}?',
                },
            },
            payoutMethods: {
                subtitle: {
                    bankAccount: 'Cuentas bancarias'
                },
                emptyText: 'No hay métodos de retirada aún',
                emptyButton: 'Añadir método de retirada',
                default: 'Por defecto',
                removeSuccess: 'Método de retirada eliminado con éxito',
                setDefaultSuccess: 'Método de retirada guardado con éxito',
            },
            payoutSchedule: {
                title: 'Pagos',
                cardInfo: 'Los pagos recibidos por los clientes se guardan en el <strong>monedero</strong> de la subentidad. Para poder transferir ese dinero a una cuenta bancaria, puedes configurar una <strong>retirada automática de fondos</strong>, con <strong>la frecuencia</strong> que mas te convenga',
                cardFrequency: {
                    title: 'Frecuencia',
                    fields: {
                        payout: 'Pago',
                    },
                    placeholders: {
                        manual: 'Manual',
                        automatic: 'Automática',
                    }
                },
                fields: {
                    paymentsStatementDescriptor: 'Payment Descriptor',
                    payoutsScheduleDelayDays: 'Día',
                    payoutsScheduleInterval: 'Frecuencia',
                    payoutsScheduleMonthlyAnchor: 'Día del mes',
                    payoutsScheduleWeeklyAnchor: 'Día de la semana',
                    payoutsStatementDescriptor: 'Payout Descriptor',
                },
                update: {
                    success: 'La frecuencia de pagos ha sido actualizada correctamente'
                }
            },
        },
        // TODO: translation revision
        customize: {    
            title: 'Personalizar subentidad ', 
            subtitle: 'Configuración de la URL, Branding de la App',
            tooltipCaption: 'Desde este apartado podrás personalizar la URL de la web y todos los contenidos de la App.',
            configurationTab: 'Configuración',
            brandTab: 'Marca',
        },
    },

    seasonSettings: {
        title: 'Configuración de la temporada',
        menu: 'Ajustes',
        league: {
            title: 'Configuración de la liga',
            subtitle: 'Rellena la información necesaria',
            tooltipCaption: 'Desde este apartado podrás crear todos los contenidos necesarios para poder crear una liga.',
            menu: 'Ajustes',
        },
    },

    programSettings: {
        publicSettings: 'Configuración pública',
        programSettings: 'Configuración de programas',
        subtitle: 'Configuración',
    },
    paymentSettings: {
        title: 'Configuración de pagos',
    },
    home: {
        nav: {
            dashboard: 'Dashboard',
            general: 'General',
            management: 'Gestión',
            wallet: 'Monedero',
            income: 'Ingresos',
            adminConfiguration: 'Configuración',
            propertyConfiguration: 'Configuración',
            subpropertyConfiguration: 'Configuración',
        },
        menu: 'Inicio',
        charts: {
            day: 'Día',
            red: 'Rojo',
            green: 'Verde',
            yellow: 'Amarillo',
            grey: 'Gris',
            blue: 'Azul',
            sales: 'Ventas',
            visitor: 'Visitas',
            months: {
                1: 'Enero',
                2: 'Febrero',
                3: 'Marzo',
                4: 'Abril',
                5: 'Mayo',
                6: 'Junio',
                7: 'Julio',
            },
            eating: 'Eating',
            drinking: 'Drinking',
            sleeping: 'Sleeping',
            designing: 'Designing',
            coding: 'Coding',
            cycling: 'Cycling',
            running: 'Running',
            customer: 'Cliente',
        },
    },

    errors: {
        backToHome: 'Back to home',
        403: `Sorry, you don't have access to this page`,
        404: 'Sorry, the page you visited does not exist',
        500: 'Sorry, the server is reporting an error',
        deleteConflict: 'Error al eliminar, contacta con support@owqlo.com por favor.',
        forbidden: {
            message: 'Forbidden',
        },
        validation: {
            message: 'An error occurred',
        },
        defaultErrorMessage: 'Ops, an error occurred',
    },
    // See https://github.com/jquense/yup#using-a-custom-locale-dictionary
    /* eslint-disabled */
    validation: {
        mixed: {
            default: '${path} es inválido',
            required: 'Campo obligatorio',
            requiredLabel: 'Campo obligatorio',
            oneOf: '${path} debe ser uno de los siguientes valores: ${values}',
            notOneOf: '${path} no debe ser uno de los siguientes valores: ${values}',
            notType: ({ path, type }) => {
                return `${path} must be a ${type}`;
            },
        },
        string: {
            length: '${path} debe tener exactamente ${length} caracteres',
            min: '${path} debe tener al menos ${min} caracteres',
            max: '${path} debe tener como máximo ${max} caracteres',
            matches: '${path} debe coindicir con: "${regex}"',
            numeric: '${path} debe contener únicamente números',
            email: '${path} debe ser un email válido',
            url: '${path} debe ser una URL válida',
            trim: '${path} debe ser un texto recortado',
            lowercase: '${path} debe ser un texto en minúsculas',
            uppercase: '${path} debe ser un texto en mayúsculas',
            selected: 'Campo obligatorio',
        },
        number: {
            min: '${path} debe ser mayor o igual que ${min}',
            max: '${path} debe ser menor o igual que${max}',
            lessThan: '${path} debe ser menor que ${less}',
            moreThan: '${path} debe ser mayor que ${more}',
            notEqual: '${path} debe ser distinto de ${notEqual}',
            positive: '${path} debe ser un número positivo',
            negative: '${path} debe ser un número negativo',
            integer: '${path} debe ser un número entero',
            invalid: '${path} debe ser un número',
        },
        date: {
            min: '${path} debe ser posterior a ${min}',
            max: '${path} debe ser anterior a ${max}',
            mustBePast: 'La fecha debe ser del pasado',
            minAge: 'Edad mínima requerida (${age})',
        },
        boolean: {},
        object: {
            noUnknown: '${path} este campo no puede tener valores no especificados',
        },
        array: {
            min: '${path} debe tener al menos ${min} objetos',
            max: '${path} debe tener como máximo ${max} objetos',
        },
    },
    /* eslint-disabled */
    fileUploader: {
        upload: 'Upload',
        uploadFile: 'Subir archivo',
        image: 'You must upload an image',
        size: 'File is too big. Max allowed size is {0}',
        formats: `File type is not accepted. This field only accepts {0} file types`,
        maxReached: 'You have reached the maximum Number of files ({0})',
        exceed: 'You can only upload 1 more file',
        exceedPlural: 'You can only upload {0} more files',
    },
    importer: {
        line: 'Line',
        status: 'Estado',
        pending: 'Pending',
        imported: 'Imported',
        error: 'Error',
        total: `{0} imported, {1} pending and {2} with error`,
        importedMessage: `Processed {0} of {1}.`,
        noNavigateAwayMessage: 'Do not navigate away from this page or import will be stopped.',
        completed: {
            success: 'Importar completed. All rows were successfully imported.',
            someErrors: 'Processing completed, but some rows were unable to be imported.',
            allErrors: 'Importar failed. There are no valid rows.',
        },
        form: {
            downloadTemplate: 'Download the template',
            hint: 'Click or drag the file to this area to continue',
        },
        list: {
            discardConfirm: 'Are you sure? Non-imported data will be lost.',
        },
        errors: {
            invalidFileEmpty: 'The file is empty',
            invalidFileExcel: 'Only excel (.xlsx) files are allowed',
            invalidFileUpload: 'Invalid file. Make sure you are using the last version of the template.',
            importHashRequired: 'Importar hash is required',
            importHashExistent: 'Data has already been imported',
        },
    },

    autocomplete: {
        loading: 'Loading...',
    },

    imagesViewer: {
        noImage: 'No image',
    },

    firebaseErrors: {
        'auth/user-disabled': 'Tu cuenta está desactivada',
        'auth/user-not-found': `Lo sentimos, no recomocemos tus credenciales`,
        'auth/wrong-password': `Lo sentimos, no recomocemos tus credenciales`,
        'auth/weak-password': 'La contraseña es poco segura',
        'auth/email-already-in-use': 'El email introducido ya está en uso',
        'auth/invalid-email': 'Por favor, introduce un email válido',
        'auth/account-exists-with-different-credential': 'El email introducido ya está en uso para un método de autenticación diferente',
        'auth/credential-already-in-use': 'Las credenciales ya están en uso',
        'auth/too-many-requests': 'Demasiados intentos de acceso fallidos. Inténtalo de nuevo más tarde',
    },

    teamRegistrationSite: {
        home: {
            welcome: 'Bienvenido al formulario de registro del Torneo MadCup',
            acceptTermsAndPrivacy: 'Acepto los <a href="https://owqlo.com/terminos-y-condiciones/" target="_blank">términos y condiciones</a> y la <a href="https://owqlo.com/politica-de-privacidad" target="_blank">política de privacidad</a>'
        },
        form: {
            step1: {
                title: 'Club',
                subtitles: {
                    homeKitColor: 'Primera equipación',
                    awayKitColor: 'Segunda equipación',
                },
            },
            step2: {
                title: 'Dirección',
            },
            step3: {
                title: 'Persona responsable',
                subtitles: {
                    personInCharge: 'Responsable'
                },
                buttons: {
                    addMore: 'Añadir otro responsable',
                },
                confirm: '¿Estás seguro de que quieres eliminar este responsable?',
            },
            step4: {
                title: 'Equipos',
                titleAlt: 'Categorías',
                labels: {
                    team: 'Equipo',
                },
                subtitles: {
                    category: 'Categoría'
                },
                buttons: {
                    addTeam: 'Añadir equipo',
                    addMore: 'Inscribir equipos a otra categoría',
                },
                confirm: '¿Estás seguro de que quieres eliminar esta categoría?',
            },
            step5: {
                title: 'Confirmación',
                subtitles: {
                    clubInformation: 'Datos del club',
                    clubAccommodation: 'Alojamiento',
                    clubKitHome: 'Primera equipación',
                    clubKitAway: 'Segunda equipación',
                    clubJerseyType: 'Tipo de camiseta:',
                    clubJerseyColor: 'Color de la camiseta:',
                    clubPantsColor: 'Color del pantalón:',
                },
                categoryGender: {
                    male: 'Masculina',
                    female: 'Femenina',
                },
            },
            step6: {
                title: '¡Felicidades!',
                subtitle: 'Se ha registrado correctamente',
                text: {
                    first: '{0}, te informamos que la inscripción de {1} se ha realizado con éxito y está pendiente de aprobación por parte de {2}.',
                    second: 'Una vez aprobada la inscripción, recibirás un correo de confirmación.',
                },
            },
            mandatoryFields: 'Campos obligatorios',
            validation: {
                allColorsRequired: 'Todos colores son necesarios para camiseta y pantalón',
                selectJerseyTypeMessage: 'Selecciona un tipo de camiseta y colores',
            },
        },
        registration: 'Inscripción',
        footer: 'Si tienes algún problema, contacta con',
    },
};

module.exports = esES;
